export const sections = [
  {
      default: 0,
      name: 'AGRICULTURE, SYLVICULTURE ET PÊCHE',
      value: 'AGRICULTURE, SYLVICULTURE ET PÊCHE',
      divisions: [
        {
          default: 0,
          name: 'Culture et production animale, chasse et services annexes',
          value: 'Culture et production animale, chasse et services annexes',
          groups: [
            {
              default: 0,
              name: 'Cultures non permanentes',
              value: 'Cultures non permanentes',
              classes: [
                { 
                  default: 0,
                  name: 'Culture de céréales (à l\'exception du riz)',
                  value: 'Culture de céréales (à l\'exception du riz)',
                },
                { 
                  default: 0,
                  name: 'Culture du riz',
                  value: 'Culture du riz',
                },
                { 
                  default: 0,
                  name: 'Culture de légumes, de melons, de racines et de tubercules',
                  value: 'Culture de légumes, de melons, de racines et de tubercules',
                },
                { 
                  default: 0,
                  name: 'Culture de la canne à sucre',
                  value: 'Culture de la canne à sucre',
                },
                { 
                  default: 0,
                  name: 'Culture du tabac',
                  value: 'Culture du tabac',
                },
                { 
                  default: 0,
                  name: 'Culture de plantes à fibres',
                  value: 'Culture de plantes à fibres',
                },
                { 
                  default: 0,
                  name: 'Culture de légumineuses et de graines oléagineuses',
                  value: 'Culture de légumineuses et de graines oléagineuses',
                },
                { 
                  default: 0,
                  name: 'Culture de fourrages',
                  value: 'Culture de fourrages',
                },
                { 
                  default: 0,
                  name: 'Horticulture et autres cultures non permanentes',
                  value: 'Horticulture et autres cultures non permanentes',
                },
              ]
            },
            {
              default: 0,
              name: 'Cultures permanentes',
              value: 'Cultures permanentes',
              classes: [
                { 
                  default: 0,
                  name: 'Culture de la vigne',
                  value: 'Culture de la vigne',
                },
                { 
                  default: 0,
                  name: 'Culture de palmiers-dattiers',
                  value: 'Culture de palmiers-dattiers',
                },
                { 
                  default: 0,
                  name: 'Culture d\'agrumes',
                  value: 'Culture d\'agrumes',
                },
                { 
                  default: 0,
                  name: 'Culture de fruits à pépins et à noyau',
                  value: 'Culture de fruits à pépins et à noyau',
                },
                { 
                  default: 0,
                  name: 'Culture d\'autres fruits d\'arbres ou d\'arbustes et de fruits à coque',
                  value: 'Culture d\'autres fruits d\'arbres ou d\'arbustes et de fruits à coque',
                },
                { 
                  default: 0,
                  name: 'Culture d\'oliviers',
                  value: 'Culture d\'oliviers',
                },
                { 
                  default: 0,
                  name: 'Culture de plantes à boissons',
                  value: 'Culture de plantes à boissons',
                },
                { 
                  default: 0,
                  name: 'Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques',
                  value: 'Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques',
                },
                { 
                  default: 0,
                  name: 'Autres cultures permanentes',
                  value: 'Autres cultures permanentes',
                },   
              ]
            },
            {
              default: 0,
              name: 'Reproduction de plantes',
              value: 'Reproduction de plantes',
              classes: [
                { 
                  default: 0,
                  name: 'Pépinières',
                  value: 'Pépinières',
                }
              ]
            },
            {
              default: 0,
              name: 'Production animale',
              value: 'Production animale',
              classes: [
                { 
                  default: 0,
                  name: 'Élevage de vaches laitières',
                  value: 'Élevage de vaches laitières',
                },
                { 
                  default: 0,
                  name: 'Élevage d\'autres bovins à viande',
                  value: 'Élevage d\'autres bovins à viande',
                },
                { 
                  default: 0,
                  name: 'Élevage de chevaux et d\'autres équidés',
                  value: 'Élevage de chevaux et d\'autres équidés',
                },
                { 
                  default: 0,
                  name: 'Élevage de chameaux et d\'autres camélidés',
                  value: 'Élevage de chameaux et d\'autres camélidés',
                },
                { 
                  default: 0,
                  name: 'Élevage d\'ovins et de caprins',
                  value: 'Élevage d\'ovins et de caprins',
                },
                { 
                  default: 0,
                  name: 'Élevage de porcins',
                  value: 'Élevage de porcins',
                },
                { 
                  default: 0,
                  name: 'Élevage de volailles',
                  value: 'Élevage de volailles',
                },
                { 
                  default: 0,
                  name: 'Élevage d\'autres animaux',
                  value: 'Élevage d\'autres animaux',
                },
              ]
            },
            {
              default: 0,
              name: 'Culture et élevage associés',
              value: 'Culture et élevage associés',
              classes: [
                { 
                  default: 0,
                  name: 'Culture et élevage associés',
                  value: 'Culture et élevage associés',
                }
              ]
            },
            {
              default: 0,
              name: 'Activités de soutien à l\'agriculture et traitement primaire des récoltes',
              value: 'Activités de soutien à l\'agriculture et traitement primaire des récoltes',
              classes: [
                { 
                  default: 0,
                  name: 'Activités de soutien aux cultures',
                  value: 'Activités de soutien aux cultures',
                },
                { 
                  default: 0,
                  name: 'Activités de soutien à la production animale',
                  value: 'Activités de soutien à la production animale',
                },
                { 
                  default: 0,
                  name: 'Traitement primaire des récoltes',
                  value: 'Traitement primaire des récoltes',
                },
                { 
                  default: 0,
                  name: 'Traitement des semences',
                  value: 'Traitement des semences',
                },
              ]
            },
            {
              default: 0,
              name: 'Chasse, piégeage et services annexes',
              value: 'Chasse, piégeage et services annexes',
              classes: [
                { 
                  default: 0,
                  name: 'Chasse, piégeage et services annexes',
                  value: 'Chasse, piégeage et services annexes',
                }
              ]
            },
          ]
        },
        {
          default: 0,
          name: 'Sylviculture et exploitation forestière',
          value: 'Sylviculture et exploitation forestière',
          groups: [
            {
              default: 0,
              name: 'Sylviculture et autres activités forestières',
              value: 'Sylviculture et autres activités forestières',
              classes: [
                { 
                  default: 0,
                  name: 'Sylviculture et autres activités forestières',
                  value: 'Sylviculture et autres activités forestières',
                },                
              ]
            },
            {
              default: 0,
              name: 'Exploitation forestière',
              value: 'Exploitation forestière',
              classes: [
                { 
                  default: 0,
                  name: 'Exploitation forestière',
                  value: 'Exploitation forestière',
                },                
              ]
            },
            {
              default: 0,
              name: 'Récolte de produits forestiers non ligneux poussant à l\'état sauvage',
              value: 'Récolte de produits forestiers non ligneux poussant à l\'état sauvage',
              classes: [
                { 
                  default: 0,
                  name: 'Récolte de l\'alfa',
                  value: 'Récolte de l\'alfa',
                },
                { 
                  default: 0,
                  name: 'Récolte du liège',
                  value: 'Récolte du liège',
                },
                { 
                  default: 0,
                  name: 'Récolte d\'autres produits forestiers non ligneux poussant à l\'état sauvage',
                  value: 'Récolte d\'autres produits forestiers non ligneux poussant à l\'état sauvage',
                },               
              ]
            },
            {
              default: 0,
              name: 'Services de soutien à l\'exploitation forestière',
              value: 'Services de soutien à l\'exploitation forestière',
              classes: [
                { 
                  default: 0,
                  name: 'Services de soutien à l\'exploitation forestière',
                  value: 'Services de soutien à l\'exploitation forestière',
                }            
              ]
            },
          ]
        },
        {
          default: 0,
          name: 'Pêche et aquaculture',
          value: 'Pêche et aquaculture',
          groups: [
            {
              default: 0,
              name: 'Pêche',
              value: 'Pêche',
              classes: [
                { 
                  default: 0,
                  name: 'Pêche en mer',
                  value: 'Pêche en mer',
                },
                { 
                  default: 0,
                  name: 'Pêche en eau douce',
                  value: 'Pêche en eau douce',
                },            
              ]
            },
            {
              default: 0,
              name: 'Aquaculture',
              value: 'Aquaculture',
              classes: [
                { 
                  default: 0,
                  name: 'Aquaculture en mer',
                  value: 'Aquaculture en mer',
                },
                { 
                  default: 0,
                  name: 'Aquaculture en eau douce',
                  value: 'Aquaculture en eau douce',
                },                
              ]
            },
          ]
        },
      ]
  },
  {
      default: 0,
      name: 'INDUSTRIES EXTRACTIVES',
      value: 'INDUSTRIES EXTRACTIVES',
      divisions: [
        {
          default: 0,
          name: 'Extraction de houille et de lignite',
          value: 'Extraction de houille et de lignite',
          groups: [
            {
              default: 0,
              name: 'Extraction de houille',
              value: 'Extraction de houille',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de houille',
                  value: 'Extraction de houille',
                },
              ]
            },
            {
              default: 0,
              name: 'Extraction de lignite',
              value: 'Extraction de lignite',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de lignite',
                  value: 'Extraction de lignite',
                },
              ]
            },
          ]
        },
        {
          default: 0,
          name: 'Extraction d\'hydrocarbures',
          value: 'Extraction d\'hydrocarbures',
          groups: [
            {
              default: 0,
              name: 'Extraction de pétrole brut',
              value: 'Extraction de pétrole brut',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de pétrole brut',
                  value: 'Extraction de pétrole brut',
                },
              ]
            },
            {
              default: 0,
              name: 'Extraction de gaz naturel',
              value: 'Extraction de gaz naturel',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de gaz naturel',
                  value: 'Extraction de gaz naturel',
                },
              ]
            },
          ]
        },
        {
          default: 0,
          name: 'Extraction de minerais métalliques',
          value: 'Extraction de minerais métalliques',
          groups: [
            {
              default: 0,
              name: 'Extraction de minerais de fer',
              value: 'Extraction de minerais de fer',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de minerais de fer',
                  value: 'Extraction de minerais de fer',
                },
              ]
            },
            {
              default: 0,
              name: 'Extraction de minerais de métaux non ferreux',
              value: 'Extraction de minerais de métaux non ferreux',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de minerais d\'uranium et de thorium',
                  value: 'Extraction de minerais d\'uranium et de thorium',
                },
                { 
                  default: 0,
                  name: 'Extraction d\'autres minerais de métaux non ferreux',
                  value: 'Extraction d\'autres minerais de métaux non ferreux',
                },
              ]
            },
          ]
        },
        {
          default: 0,
          name: 'Autres industries extractives',
          value: 'Autres industries extractives',
          groups: [
            {
              default: 0,
              name: 'Extraction de pierres, de sables et d\'argiles',
              value: 'Extraction de pierres, de sables et d\'argiles',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de pierres ornementales et de construction, de calcaire industriel, de gypse,de craie et d\'ardoise',
                  value: 'Extraction de pierres ornementales et de construction, de calcaire industriel, de gypse,de craie et d\'ardoise',
                },
                { 
                  default: 0,
                  name: 'Exploitation de gravières et sablières, extraction d\'argiles et de kaolin',
                  value: 'Exploitation de gravières et sablières, extraction d\'argiles et de kaolin',
                },
              ]
            },
            {
              default: 0,
              name: 'Extraction de phosphates naturels',
              value: 'Extraction de phosphates naturels',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction de phosphates naturels',
                  value: 'Extraction de phosphates naturels',
                },
              ]
            },
            {
              default: 0,
              name: 'Activités extractives n.c.a.',
              value: 'Activités extractives n.c.a.',
              classes: [
                { 
                  default: 0,
                  name: 'Extraction des minéraux chimique et d\'engrais minéraux (sauf phosphates)',
                  value: 'Extraction des minéraux chimique et d\'engrais minéraux (sauf phosphates)',
                },
                { 
                  default: 0,
                  name: 'Extraction de tourbe',
                  value: 'Extraction de tourbe',
                },
                { 
                  default: 0,
                  name: 'Production de sel',
                  value: 'Production de sel',
                },
                { 
                  default: 0,
                  name: 'Autres activités extractives n.c.a.',
                  value: 'Autres activités extractives n.c.a.',
                },
              ]
            },
          ]
        },
        {
          default: 0,
          name: 'Services de soutien aux industries extractives',
          value: 'Services de soutien aux industries extractives',
          groups: [
            {
              default: 0,
              name: 'Activités de soutien à l\'extraction d\'hydrocarbures',
              value: 'Activités de soutien à l\'extraction d\'hydrocarbures',
              classes: [
                { 
                  default: 0,
                  name: 'Activités de soutien à l\'extraction d\'hydrocarbures',
                  value: 'Activités de soutien à l\'extraction d\'hydrocarbures',
                },
              ]
            },
            {
              default: 0,
              name: 'Activités de soutien aux autres industries extractives',
              value: 'Activités de soutien aux autres industries extractives',
              classes: [
                { 
                  default: 0,
                  name: 'Activités de soutien aux autres industries extractives',
                  value: 'Activités de soutien aux autres industries extractives',
                },
              ]
            },
          ]
        },
        // ... other divisions
      ]
  },
  {
    default: 0,
    name: 'INDUSTRIE MANUFACTURIÈRE',
    value: 'INDUSTRIE MANUFACTURIÈRE',
    divisions: [
      {
        default: 0,
        name: 'Industries alimentaires',
        value: 'Industries alimentaires',
        groups: [
          {
            default: 0,
            name: 'Transformation et conservation de la viande et préparation de produits à base de viande',
            value: 'Transformation et conservation de la viande et préparation de produits à base de viande',
            classes: [
              { 
                default: 0,
                name: 'Transformation et conservation de la viande de boucherie',
                value: 'Transformation et conservation de la viande de boucherie',
              },
              { 
                default: 0,
                name: 'Transformation et conservation de la viande de volaille',
                value: 'Transformation et conservation de la viande de volaille',
              },
              { 
                default: 0,
                name: 'Préparation de produits à base de viande',
                value: 'Préparation de produits à base de viande',
              },
            ]
          },
          {
            default: 0,
            name: 'Transformation et conservation de poisson, de crustacés et de mollusques',
            value: 'Transformation et conservation de poisson, de crustacés et de mollusques',
            classes: [
              { 
                default: 0,
                name: 'Transformation et conservation de poisson, de crustacés et de mollusques',
                value: 'Transformation et conservation de poisson, de crustacés et de mollusques',
              },
            ]
          },
          {
            default: 0,
            name: 'Transformation et conservation de fruits et légumes',
            value: 'Transformation et conservation de fruits et légumes',
            classes: [
              { 
                default: 0,
                name: 'Transformation et conservation de pommes de terre',
                value: 'Transformation et conservation de pommes de terre',
              },
              { 
                default: 0,
                name: 'Préparation de jus de fruits et légumes',
                value: 'Préparation de jus de fruits et légumes',
              },
              { 
                default: 0,
                name: 'Transformation et conservation de tomates',
                value: 'Transformation et conservation de tomates',
              },
              { 
                default: 0,
                name: 'Transformation et conservation d\'autres légumes, sauf tomates',
                value: 'Transformation et conservation d\'autres légumes, sauf tomates',
              },
              { 
                default: 0,
                name: 'Transformation et conservation de fruits',
                value: 'Transformation et conservation de fruits',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'huiles et graisses végétales et animales',
            value: 'Fabrication d\'huiles et graisses végétales et animales',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'huiles d\'olives',
                value: 'Fabrication d\'huiles d\'olives',
              },
              { 
                default: 0,
                name: 'Fabrication d\'huiles et graisses brutes',
                value: 'Fabrication d\'huiles et graisses brutes',
              },
              { 
                default: 0,
                name: 'Fabrication d\'huiles et graisses raffinées',
                value: 'Fabrication d\'huiles et graisses raffinées',
              },
              { 
                default: 0,
                name: 'Fabrication de margarine et graisses comestibles similaires',
                value: 'Fabrication de margarine et graisses comestibles similaires',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de produits laitiers',
            value: 'Fabrication de produits laitiers',
            classes: [
              { 
                default: 0,
                name: 'Exploitation de laiteries et fabrication de fromage',
                value: 'Exploitation de laiteries et fabrication de fromage',
              },
              { 
                default: 0,
                name: 'Fabrication de glaces et sorbets',
                value: 'Fabrication de glaces et sorbets',
              }
            ]
          },
          {
            default: 0,
            name: 'Travail des grains; fabrication de produits amylacés',
            value: 'Travail des grains; fabrication de produits amylacés',
            classes: [
              { 
                default: 0,
                name: 'Meunerie',
                value: 'Meunerie',
              },
              { 
                default: 0,
                name: 'Fabrication de produits amylacés',
                value: 'Fabrication de produits amylacés',
              },
              { 
                default: 0,
                name: 'Autres activités de travail des grains',
                value: 'Autres activités de travail des grains',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de produits de boulangerie pâtisserie et de pâtes alimentaires',
            value: 'Fabrication de produits de boulangerie pâtisserie et de pâtes alimentaires',
            classes: [
              { 
                default: 0,
                name: 'Boulangerie et boulangerie-pâtisserie',
                value: 'Boulangerie et boulangerie-pâtisserie',
              },
              { 
                default: 0,
                name: 'Pâtisserie (exclusive)',
                value: 'Pâtisserie (exclusive)',
              },
              { 
                default: 0,
                name: 'Fabrication de biscuits, biscottes et pâtisseries de conservation',
                value: 'Fabrication de biscuits, biscottes et pâtisseries de conservation',
              },
              { 
                default: 0,
                name: 'Fabrication de pâtes alimentaires et couscous',
                value: 'Fabrication de pâtes alimentaires et couscous',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres produits alimentaires',
            value: 'Fabrication d\'autres produits alimentaires',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de sucre',
                value: 'Fabrication de sucre',
              },
              { 
                default: 0,
                name: 'Fabrication de cacao, chocolat et de produits de confiserie',
                value: 'Fabrication de cacao, chocolat et de produits de confiserie',
              },
              { 
                default: 0,
                name: 'Transformation du thé et du café',
                value: 'Transformation du thé et du café',
              },
              { 
                default: 0,
                name: 'Fabrication de condiments et assaisonnements',
                value: 'Fabrication de condiments et assaisonnements',
              },
              { 
                default: 0,
                name: 'Fabrication de plats préparés',
                value: 'Fabrication de plats préparés',
              },
              { 
                default: 0,
                name: 'Fabrication d\'aliments homogénéisés et diététiques',
                value: 'Fabrication d\'aliments homogénéisés et diététiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits alimentaires n.c.a.',
                value: 'Fabrication d\'autres produits alimentaires n.c.a.',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'aliments pour animaux',
            value: 'Fabrication d\'aliments pour animaux',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'aliments pour animaux de ferme',
                value: 'Fabrication d\'aliments pour animaux de ferme',
              },
              { 
                default: 0,
                name: 'Fabrication d\'aliments pour animaux de compagnie',
                value: 'Fabrication d\'aliments pour animaux de compagnie',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Fabrication de boissons',
        value: 'Fabrication de boissons',
        groups: [
          {
            default: 0,
            name: 'Fabrication de boissons',
            value: 'Fabrication de boissons',
            classes: [
              { 
                default: 0,
                name: 'Production de boissons alcooliques distillées',
                value: 'Production de boissons alcooliques distillées',
              },
              { 
                default: 0,
                name: 'Production de vin (de raisin)',
                value: 'Production de vin (de raisin)',
              },
              { 
                default: 0,
                name: 'Fabrication de cidre et de vins de fruits',
                value: 'Fabrication de cidre et de vins de fruits',
              },
              { 
                default: 0,
                name: 'Production d\'autres boissons fermentées non distillées',
                value: 'Production d\'autres boissons fermentées non distillées',
              },
              { 
                default: 0,
                name: 'Fabrication de bière',
                value: 'Fabrication de bière',
              },
              { 
                default: 0,
                name: 'Fabrication de malt',
                value: 'Fabrication de malt',
              },
              { 
                default: 0,
                name: 'Industrie des eaux minérales et gazeuses',
                value: 'Industrie des eaux minérales et gazeuses',
              },
              { 
                default: 0,
                name: 'Production de boissons rafraîchissantes',
                value: 'Production de boissons rafraîchissantes',
              },
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Fabrication de produits à base de tabac',
        value: 'Fabrication de produits à base de tabac',
        groups: [
          {
            default: 0,
            name: 'Fabrication de produits à base de tabac',
            value: 'Fabrication de produits à base de tabac',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de produits à base de tabac',
                value: 'Fabrication de produits à base de tabac',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication de textiles',
        value: 'Fabrication de textiles',
        groups: [
          {
            default: 0,
            name: 'Préparation de fibres textiles et filature',
            value: 'Préparation de fibres textiles et filature',
            classes: [
              { 
                default: 0,
                name: 'Préparation de fibres textiles et filature',
                value: 'Préparation de fibres textiles et filature',
              }
            ]
          },
          {
            default: 0,
            name: 'Tissage',
            value: 'Tissage',
            classes: [
              { 
                default: 0,
                name: 'Tissage industriel',
                value: 'Tissage industriel',
              },
              { 
                default: 0,
                name: 'Tissage traditionnel',
                value: 'Tissage traditionnel',
              },
            ]
          },
          {
            default: 0,
            name: 'Ennoblissement textile',
            value: 'Ennoblissement textile',
            classes: [
              { 
                default: 0,
                name: 'Ennoblissement textile',
                value: 'Ennoblissement textile',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de tapis et moquettes',
            value: 'Fabrication de tapis et moquettes',
            classes: [
              { 
                default: 0,
                name: 'Fabrication industrielle de tapis et moquettes',
                value: 'Fabrication industrielle de tapis et moquettes',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale de tapis',
                value: 'Fabrication artisanale de tapis',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres textiles',
            value: 'Fabrication d\'autres textiles',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'étoffes à mailles',
                value: 'Fabrication d\'étoffes à mailles',
              },
              { 
                default: 0,
                name: 'Fabrication indusrielle de linge domestique, d\'articles d\'ameublement et de literie',
                value: 'Fabrication indusrielle de linge domestique, d\'articles d\'ameublement et de literie',
              },
              { 
                default: 0,
                name: 'fabrication industrielle d\'autres articles textiles, sauf habillement',
                value: 'fabrication industrielle d\'autres articles textiles, sauf habillement',
              },
              { 
                default: 0,
                name: 'Fabrication de ficelles, cordes et filets',
                value: 'Fabrication de ficelles, cordes et filets',
              },
              { 
                default: 0,
                name: 'Fabrication de non-tissés, sauf habillement',
                value: 'Fabrication de non-tissés, sauf habillement',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres textiles techniques et industriels',
                value: 'Fabrication d\'autres textiles techniques et industriels',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale d\'articles textiles traditionnels',
                value: 'Fabrication artisanale d\'articles textiles traditionnels',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres textiles n.c.a.',
                value: 'Fabrication d\'autres textiles n.c.a.',
              },
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Industrie de l\'habillement',
        value: 'Industrie de l\'habillement',
        groups: [
          {
            default: 0,
            name: 'Fabrication de vêtements, autres qu\'en fourrure',
            value: 'Fabrication de vêtements, autres qu\'en fourrure',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de vêtements en cuir',
                value: 'Fabrication de vêtements en cuir',
              },
              { 
                default: 0,
                name: 'Fabrication de vêtements de travail',
                value: 'Fabrication de vêtements de travail',
              },
              { 
                default: 0,
                name: 'Fabrication de vêtements sur mesure',
                value: 'Fabrication de vêtements sur mesure',
              },
              { 
                default: 0,
                name: 'Fabrication industrielle de vêtements de dessus',
                value: 'Fabrication industrielle de vêtements de dessus',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale de vêtements traditionnels',
                value: 'Fabrication artisanale de vêtements traditionnels',
              },
              { 
                default: 0,
                name: 'Fabrication de vêtements de dessous',
                value: 'Fabrication de vêtements de dessous',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres vêtements et accessoires',
                value: 'Fabrication d\'autres vêtements et accessoires',
              },
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'articles en fourrure',
            value: 'Fabrication d\'articles en fourrure',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'articles en fourrure',
                value: 'Fabrication d\'articles en fourrure',
              },
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'articles à mailles',
            value: 'Fabrication d\'articles à mailles',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'articles chaussants à mailles',
                value: 'Fabrication d\'articles chaussants à mailles',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres articles à mailles',
                value: 'Fabrication d\'autres articles à mailles',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Industrie du cuir et de la chaussure',
        value: 'Industrie du cuir et de la chaussure',
        groups: [
          {
            default: 0,
            name: 'Apprêt et tannage des cuirs; préparation et teinture des fourrures; fabrication d\'articlesde voyage, de maroquinerie et de sellerie',
            value: 'Apprêt et tannage des cuirs; préparation et teinture des fourrures; fabrication d\'articlesde voyage, de maroquinerie et de sellerie',
            classes: [
              { 
                default: 0,
                name: 'Apprêt et tannage des cuirs; préparation et teinture des fourrures',
                value: 'Apprêt et tannage des cuirs; préparation et teinture des fourrures',
              },
              { 
                default: 0,
                name: 'Fabrication d\'articles de voyage, de maroquinerie et de sellerie',
                value: 'Fabrication d\'articles de voyage, de maroquinerie et de sellerie',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de chaussures',
            value: 'Fabrication de chaussures',
            classes: [
              { 
                default: 0,
                name: 'Fabrication indusrielle de chaussures',
                value: 'Fabrication indusrielle de chaussures',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale de chaussures traditionnelles',
                value: 'Fabrication artisanale de chaussures traditionnelles',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Travail du bois et fabrication d\'articles en bois et en liège, à l\'exception des',
        value: 'Travail du bois et fabrication d\'articles en bois et en liège, à l\'exception des',
        groups: [
          {
            default: 0,
            name: 'Sciage et rabotage du bois',
            value: 'Sciage et rabotage du bois',
            classes: [
              { 
                default: 0,
                name: 'Sciage et rabotage du bois',
                value: 'Sciage et rabotage du bois',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'articles en bois, liège, vannerie et sparterie',
            value: 'Fabrication d\'articles en bois, liège, vannerie et sparterie',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de placage et de panneaux de bois',
                value: 'Fabrication de placage et de panneaux de bois',
              },
              { 
                default: 0,
                name: 'Fabrication de parquets assemblés',
                value: 'Fabrication de parquets assemblés',
              },
              { 
                default: 0,
                name: 'Fabrication de charpentes et d\'autres menuiseries',
                value: 'Fabrication de charpentes et d\'autres menuiseries',
              },
              { 
                default: 0,
                name: 'Fabrication d\'emballages en bois',
                value: 'Fabrication d\'emballages en bois',
              },
              { 
                default: 0,
                name: 'Fabrication industrielle d\'objets divers en bois',
                value: 'Fabrication industrielle d\'objets divers en bois',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale d\'objets divers en bois, d\'objets en liège, vannerie et sparterie',
                value: 'Fabrication artisanale d\'objets divers en bois, d\'objets en liège, vannerie et sparterie',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Industrie du papier et du carton',
        value: 'Industrie du papier et du carton',
        groups: [
          {
            default: 0,
            name: 'Fabrication de pâte à papier, de papier et de carton',
            value: 'Fabrication de pâte à papier, de papier et de carton',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de pâte à papier',
                value: 'Fabrication de pâte à papier',
              },
              { 
                default: 0,
                name: 'Fabrication de papier et de carton',
                value: 'Fabrication de papier et de carton',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'articles en papier ou en carton',
            value: 'Fabrication d\'articles en papier ou en carton',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de papier et carton ondulés et d\'emballages en papier ou en carton',
                value: 'Fabrication de papier et carton ondulés et d\'emballages en papier ou en carton',
              },
              { 
                default: 0,
                name: 'Fabrication d\'articles en papier à usage sanitaire ou domestique',
                value: 'Fabrication d\'articles en papier à usage sanitaire ou domestique',
              },
              { 
                default: 0,
                name: 'Fabrication d\'articles de papeterie',
                value: 'Fabrication d\'articles de papeterie',
              },
              { 
                default: 0,
                name: 'Fabrication de papiers peints',
                value: 'Fabrication de papiers peints',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres articles en papier ou en carton',
                value: 'Fabrication d\'autres articles en papier ou en carton',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Imprimerie et reproduction d\'enregistrements',
        value: 'Imprimerie et reproduction d\'enregistrements',
        groups: [
          {
            default: 0,
            name: 'Imprimerie et services annexes',
            value: 'Imprimerie et services annexes',
            classes: [
              { 
                default: 0,
                name: 'Imprimerie de journaux',
                value: 'Imprimerie de journaux',
              },
              { 
                default: 0,
                name: 'Autre imprimerie (labeur)',
                value: 'Autre imprimerie (labeur)',
              },
              { 
                default: 0,
                name: 'Activités de pré-presse',
                value: 'Activités de pré-presse',
              },
              { 
                default: 0,
                name: 'Reliure et activités connexes',
                value: 'Reliure et activités connexes',
              }
            ]
          },
          {
            default: 0,
            name: 'Reproduction d\'enregistrements',
            value: 'Reproduction d\'enregistrements',
            classes: [
              { 
                default: 0,
                name: 'Reproduction d\'enregistrements',
                value: 'Reproduction d\'enregistrements',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Cokéfaction et raffinage',
        value: 'Cokéfaction et raffinage',
        groups: [
          {
            default: 0,
            name: 'Cokéfaction',
            value: 'Cokéfaction',
            classes: [
              { 
                default: 0,
                name: 'Cokéfaction',
                value: 'Cokéfaction',
              }
            ]
          },
          {
            default: 0,
            name: 'Raffinage du pétrole',
            value: 'Raffinage du pétrole',
            classes: [
              { 
                default: 0,
                name: 'Raffinage du pétrole',
                value: 'Raffinage du pétrole',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Industrie chimique',
        value: 'Industrie chimique',
        groups: [
          {
            default: 0,
            name: 'Fabrication de produits chimiques de base, de produits azotés et d\'engrais, de matières plastiques de base et de caoutchouc synthétique',
            value: 'Fabrication de produits chimiques de base, de produits azotés et d\'engrais, de matières plastiques de base et de caoutchouc synthétique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de gaz industriels',
                value: 'Fabrication de gaz industriels',
              },
              { 
                default: 0,
                name: 'Fabrication de colorants et de pigments',
                value: 'Fabrication de colorants et de pigments',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits chimiques inorganiques de base',
                value: 'Fabrication d\'autres produits chimiques inorganiques de base',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits chimiques organiques de base',
                value: 'Fabrication d\'autres produits chimiques organiques de base',
              },
              { 
                default: 0,
                name: 'Fabrication de produits azotés et d\'engrais',
                value: 'Fabrication de produits azotés et d\'engrais',
              },
              { 
                default: 0,
                name: 'Fabrication de matières plastiques de base',
                value: 'Fabrication de matières plastiques de base',
              },
              { 
                default: 0,
                name: 'Fabrication de caoutchouc synthétique',
                value: 'Fabrication de caoutchouc synthétique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de pesticides et d\'autres produits agrochimiques',
            value: 'Fabrication de pesticides et d\'autres produits agrochimiques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de pesticides et d\'autres produits agrochimiques',
                value: 'Fabrication de pesticides et d\'autres produits agrochimiques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de peintures, vernis, encres et mastics',
            value: 'Fabrication de peintures, vernis, encres et mastics',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de peintures, vernis, encres et mastics',
                value: 'Fabrication de peintures, vernis, encres et mastics',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de savons, de produits d\'entretien et de parfums',
            value: 'Fabrication de savons, de produits d\'entretien et de parfums',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de savons, détergents et produits d\'entretien',
                value: 'Fabrication de savons, détergents et produits d\'entretien',
              },
              { 
                default: 0,
                name: 'Fabrication de parfums et de produits pour la toilette',
                value: 'Fabrication de parfums et de produits pour la toilette',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres produits chimiques',
            value: 'Fabrication d\'autres produits chimiques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de produits explosifs',
                value: 'Fabrication de produits explosifs',
              },
              { 
                default: 0,
                name: 'Fabrication de colles',
                value: 'Fabrication de colles',
              },
              { 
                default: 0,
                name: 'Fabrication d\'huiles essentielles',
                value: 'Fabrication d\'huiles essentielles',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits chimiques n.c.a.',
                value: 'Fabrication d\'autres produits chimiques n.c.a.',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de fibres artificielles ou synthétiques',
            value: 'Fabrication de fibres artificielles ou synthétiques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de fibres artificielles ou synthétiques',
                value: 'Fabrication de fibres artificielles ou synthétiques',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Industrie pharmaceutique',
        value: 'Industrie pharmaceutique',
        groups: [
          {
            default: 0,
            name: 'Fabrication de produits pharmaceutiques de base',
            value: 'Fabrication de produits pharmaceutiques de base',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de produits pharmaceutiques de base',
                value: 'Fabrication de produits pharmaceutiques de base',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de préparations pharmaceutiques',
            value: 'Fabrication de préparations pharmaceutiques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de préparations pharmaceutiques',
                value: 'Fabrication de préparations pharmaceutiques',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication de produits en caoutchouc et en plastique',
        value: 'Fabrication de produits en caoutchouc et en plastique',
        groups: [
          {
            default: 0,
            name: 'Fabrication de produits en caoutchouc',
            value: 'Fabrication de produits en caoutchouc',
            classes: [
              { 
                default: 0,
                name: 'Fabrication et rechapage de pneumatiques',
                value: 'Fabrication et rechapage de pneumatiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres articles en caoutchouc',
                value: 'Fabrication d\'autres articles en caoutchouc',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de produits en plastique',
            value: 'Fabrication de produits en plastique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de plaques, feuilles, tubes et profilés en matières plastiques',
                value: 'Fabrication de plaques, feuilles, tubes et profilés en matières plastiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'emballages en matières plastiques',
                value: 'Fabrication d\'emballages en matières plastiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'éléments en matières plastiques pour la construction',
                value: 'Fabrication d\'éléments en matières plastiques pour la construction',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres articles en matières plastiques',
                value: 'Fabrication d\'autres articles en matières plastiques',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication d\'autres produits minéraux non métalliques',
        value: 'Fabrication d\'autres produits minéraux non métalliques',
        groups: [
          {
            default: 0,
            name: 'Fabrication de verre et d\'articles en verre',
            value: 'Fabrication de verre et d\'articles en verre',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de verre plat',
                value: 'Fabrication de verre plat',
              },
              { 
                default: 0,
                name: 'Façonnage et transformation du verre plat',
                value: 'Façonnage et transformation du verre plat',
              },
              { 
                default: 0,
                name: 'Fabrication de verre creux',
                value: 'Fabrication de verre creux',
              },
              { 
                default: 0,
                name: 'Fabrication de fibres de verre',
                value: 'Fabrication de fibres de verre',
              },
              { 
                default: 0,
                name: 'Fabrication et façonnage d\'autres articles en verre, y compris verre technique',
                value: 'Fabrication et façonnage d\'autres articles en verre, y compris verre technique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de produits réfractaires',
            value: 'Fabrication de produits réfractaires',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de produits réfractaires',
                value: 'Fabrication de produits réfractaires',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de matériaux de construction en terre cuite',
            value: 'Fabrication de matériaux de construction en terre cuite',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de carreaux en céramique',
                value: 'Fabrication de carreaux en céramique',
              },
              { 
                default: 0,
                name: 'Fabrication de briques, tuiles et produits de construction, en terre cuite',
                value: 'Fabrication de briques, tuiles et produits de construction, en terre cuite',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres produits en céramique et en porcelaine',
            value: 'Fabrication d\'autres produits en céramique et en porcelaine',
            classes: [
              { 
                default: 0,
                name: 'Fabrication industrielle d\'articles céramiques à usage domestique ou ornemental',
                value: 'Fabrication industrielle d\'articles céramiques à usage domestique ou ornemental',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale d\'articles céramiques à usage domestique ou ornemental',
                value: 'Fabrication artisanale d\'articles céramiques à usage domestique ou ornemental',
              },
              { 
                default: 0,
                name: 'Fabrication d\'appareils sanitaires en céramique',
                value: 'Fabrication d\'appareils sanitaires en céramique',
              },
              { 
                default: 0,
                name: 'Fabrication d\'isolateurs et pièces isolantes en céramique',
                value: 'Fabrication d\'isolateurs et pièces isolantes en céramique',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits céramiques à usage technique',
                value: 'Fabrication d\'autres produits céramiques à usage technique',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits céramiques',
                value: 'Fabrication d\'autres produits céramiques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de ciment, chaux et plâtre',
            value: 'Fabrication de ciment, chaux et plâtre',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de ciment',
                value: 'Fabrication de ciment',
              },
              { 
                default: 0,
                name: 'Fabrication de chaux et plâtre',
                value: 'Fabrication de chaux et plâtre',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'ouvrages en béton, en ciment ou en plâtre',
            value: 'Fabrication d\'ouvrages en béton, en ciment ou en plâtre',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'éléments en béton pour la construction',
                value: 'Fabrication d\'éléments en béton pour la construction',
              },
              { 
                default: 0,
                name: 'Fabrication d\'éléments en plâtre pour la construction',
                value: 'Fabrication d\'éléments en plâtre pour la construction',
              },
              { 
                default: 0,
                name: 'Fabrication de béton prêt à l\'emploi',
                value: 'Fabrication de béton prêt à l\'emploi',
              },
              { 
                default: 0,
                name: 'Fabrication de mortiers et bétons secs',
                value: 'Fabrication de mortiers et bétons secs',
              },
              { 
                default: 0,
                name: 'Fabrication d\'ouvrages en fibre ciment',
                value: 'Fabrication d\'ouvrages en fibre ciment',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres ouvrages en béton, en ciment ou en plâtre',
                value: 'Fabrication d\'autres ouvrages en béton, en ciment ou en plâtre',
              }
            ]
          },
          {
            default: 0,
            name: 'Taille, façonnage et finissage de pierres',
            value: 'Taille, façonnage et finissage de pierres',
            classes: [
              { 
                default: 0,
                name: 'Taille, façonnage et finissage de pierres',
                value: 'Taille, façonnage et finissage de pierres',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de produits abrasifs et de produits minéraux non métalliques n.c.a.',
            value: 'Fabrication de produits abrasifs et de produits minéraux non métalliques n.c.a.',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de produits abrasifs',
                value: 'Fabrication de produits abrasifs',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres produits minéraux non métalliques n.c.a.',
                value: 'Fabrication d\'autres produits minéraux non métalliques n.c.a.',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Métallurgie',
        value: 'Métallurgie',
        groups: [
          {
            default: 0,
            name: 'Sidérurgie',
            value: 'Sidérurgie',
            classes: [
              { 
                default: 0,
                name: 'Sidérurgie',
                value: 'Sidérurgie',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier',
            value: 'Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier',
                value: 'Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres produits de première transformation de l\'acier',
            value: 'Fabrication d\'autres produits de première transformation de l\'acier',
            classes: [
              { 
                default: 0,
                name: 'Étirage à froid de barres',
                value: 'Étirage à froid de barres',
              },
              { 
                default: 0,
                name: 'Laminage à froid de feuillards',
                value: 'Laminage à froid de feuillards',
              },
              { 
                default: 0,
                name: 'Profilage à froid par formage ou pliage',
                value: 'Profilage à froid par formage ou pliage',
              },
              { 
                default: 0,
                name: 'Tréfilage à froid',
                value: 'Tréfilage à froid',
              }
            ]
          },
          {
            default: 0,
            name: 'Production de métaux précieux et d\'autres métaux non ferreux',
            value: 'Production de métaux précieux et d\'autres métaux non ferreux',
            classes: [
              { 
                default: 0,
                name: 'Production de métaux précieux',
                value: 'Production de métaux précieux',
              },
              { 
                default: 0,
                name: 'Métallurgie de l\'aluminium',
                value: 'Métallurgie de l\'aluminium',
              },
              { 
                default: 0,
                name: 'Métallurgie du plomb, du zinc ou de l\'étain',
                value: 'Métallurgie du plomb, du zinc ou de l\'étain',
              },
              { 
                default: 0,
                name: 'Métallurgie du cuivre',
                value: 'Métallurgie du cuivre',
              },
              { 
                default: 0,
                name: 'Métallurgie des autres métaux non ferreux',
                value: 'Métallurgie des autres métaux non ferreux',
              },
              { 
                default: 0,
                name: 'Élaboration et transformation de matières nucléaires',
                value: 'Élaboration et transformation de matières nucléaires',
              }
            ]
          },
          {
            default: 0,
            name: 'Fonderie',
            value: 'Fonderie',
            classes: [
              { 
                default: 0,
                name: 'Fonderie de fonte',
                value: 'Fonderie de fonte',
              },
              { 
                default: 0,
                name: 'Fonderie d\'acier',
                value: 'Fonderie d\'acier',
              },
              { 
                default: 0,
                name: 'Fonderie de métaux légers',
                value: 'Fonderie de métaux légers',
              },
              { 
                default: 0,
                name: 'Fonderie d\'autres métaux non ferreux',
                value: 'Fonderie d\'autres métaux non ferreux',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication de produits métalliques, à l\'exception des machines et des équipements',
        value: 'Fabrication de produits métalliques, à l\'exception des machines et des équipements',
        groups: [
          {
            default: 0,
            name: 'Fabrication d\'éléments en métal pour la construction',
            value: 'Fabrication d\'éléments en métal pour la construction',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de structures métalliques et de parties de structures',
                value: 'Fabrication de structures métalliques et de parties de structures',
              },
              { 
                default: 0,
                name: 'Fabrication de portes et fenêtres en métal',
                value: 'Fabrication de portes et fenêtres en métal',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de réservoirs, citernes et conteneurs métalliques',
            value: 'Fabrication de réservoirs, citernes et conteneurs métalliques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de radiateurs et de chaudières pour le chauffage central',
                value: 'Fabrication de radiateurs et de chaudières pour le chauffage central',
              },
              { 
                default: 0,
                name: 'Fabrication de récipients métalliques pour gaz comprimés ou liquéfiés',
                value: 'Fabrication de récipients métalliques pour gaz comprimés ou liquéfiés',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres réservoirs, citernes et conteneurs métalliques',
                value: 'Fabrication d\'autres réservoirs, citernes et conteneurs métalliques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de générateurs de vapeur, à l\'exception des chaudières pour le chauffage central',
            value: 'Fabrication de générateurs de vapeur, à l\'exception des chaudières pour le chauffage central',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de générateurs de vapeur, à l\'exception des chaudières pour le chauffage central',
                value: 'Fabrication de générateurs de vapeur, à l\'exception des chaudières pour le chauffage central',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'armes et de munitions',
            value: 'Fabrication d\'armes et de munitions',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'armes et de munitions',
                value: 'Fabrication d\'armes et de munitions',
              }
            ]
          },
          {
            default: 0,
            name: 'Forge, emboutissage, estampage; métallurgie des poudres',
            value: 'Forge, emboutissage, estampage; métallurgie des poudres',
            classes: [
              { 
                default: 0,
                name: 'Forge, emboutissage, estampage; métallurgie des poudres',
                value: 'Forge, emboutissage, estampage; métallurgie des poudres',
              }
            ]
          },
          {
            default: 0,
            name: 'Traitement et revêtement des métaux; usinage',
            value: 'Traitement et revêtement des métaux; usinage',
            classes: [
              { 
                default: 0,
                name: 'Traitement et revêtement des métaux',
                value: 'Traitement et revêtement des métaux',
              },
              { 
                default: 0,
                name: 'Usinage',
                value: 'Usinage',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de coutellerie, d\'outillage et de quincaillerie',
            value: 'Fabrication de coutellerie, d\'outillage et de quincaillerie',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de coutellerie',
                value: 'Fabrication de coutellerie',
              },
              { 
                default: 0,
                name: 'Fabrication de serrures et de ferrures',
                value: 'Fabrication de serrures et de ferrures',
              },
              { 
                default: 0,
                name: 'Fabrication d\'outillage à main',
                value: 'Fabrication d\'outillage à main',
              },
              { 
                default: 0,
                name: 'Fabrication d\'outillage mécanique',
                value: 'Fabrication d\'outillage mécanique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres ouvrages en métaux',
            value: 'Fabrication d\'autres ouvrages en métaux',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de fûts et emballages métalliques similaires',
                value: 'Fabrication de fûts et emballages métalliques similaires',
              },
              { 
                default: 0,
                name: 'Fabrication d\'emballages métalliques légers',
                value: 'Fabrication d\'emballages métalliques légers',
              },
              { 
                default: 0,
                name: 'Fabrication d\'articles en fils métalliques, de chaînes et de ressorts',
                value: 'Fabrication d\'articles en fils métalliques, de chaînes et de ressorts',
              },
              { 
                default: 0,
                name: 'Fabrication de vis et de boulons',
                value: 'Fabrication de vis et de boulons',
              },
              { 
                default: 0,
                name: 'Fabrication artisanale d\'ouvrages traditionnels en métaux',
                value: 'Fabrication artisanale d\'ouvrages traditionnels en métaux',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres ouvrages métalliques n.c.a.',
                value: 'Fabrication d\'autres ouvrages métalliques n.c.a.',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication de produits informatiques, électroniques et optiques',
        value: 'Fabrication de produits informatiques, électroniques et optiques',
        groups: [
          {
            default: 0,
            name: 'Fabrication de composants et cartes électroniques',
            value: 'Fabrication de composants et cartes électroniques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de composants électroniques',
                value: 'Fabrication de composants électroniques',
              },
              { 
                default: 0,
                name: 'Fabrication de cartes électroniques assemblées',
                value: 'Fabrication de cartes électroniques assemblées',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'ordinateurs et d\'équipements périphériques',
            value: 'Fabrication d\'ordinateurs et d\'équipements périphériques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'ordinateurs et d\'équipements périphériques',
                value: 'Fabrication d\'ordinateurs et d\'équipements périphériques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'équipements de communication',
            value: 'Fabrication d\'équipements de communication',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'équipements de communication',
                value: 'Fabrication d\'équipements de communication',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de produits électroniques grand public',
            value: 'Fabrication de produits électroniques grand public',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de produits électroniques grand public',
                value: 'Fabrication de produits électroniques grand public',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'instruments et d\'appareils de mesure, d\'essai et de navigation; horlogerie',
            value: 'Fabrication d\'instruments et d\'appareils de mesure, d\'essai et de navigation; horlogerie',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'instruments et d\'appareils de mesure, d\'essai et de navigation',
                value: 'Fabrication d\'instruments et d\'appareils de mesure, d\'essai et de navigation',
              },
              { 
                default: 0,
                name: 'Horlogerie',
                value: 'Horlogerie',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'équipements d\'irradiation médicale, d\'équipements électromédicaux et électrothérapeutiques',
            value: 'Fabrication d\'équipements d\'irradiation médicale, d\'équipements électromédicaux et électrothérapeutiques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'équipements d\'irradiation médicale, d\'équipements électromédicaux et électrothérapeutiques',
                value: 'Fabrication d\'équipements d\'irradiation médicale, d\'équipements électromédicaux et électrothérapeutiques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de matériels optique et photographique',
            value: 'Fabrication de matériels optique et photographique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de matériels optique et photographique',
                value: 'Fabrication de matériels optique et photographique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de supports magnétiques et optiques',
            value: 'Fabrication de supports magnétiques et optiques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de supports magnétiques et optiques',
                value: 'Fabrication de supports magnétiques et optiques',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication d\'équipements électriques',
        value: 'Fabrication d\'équipements électriques',
        groups: [
          {
            default: 0,
            name: 'Fabrication de moteurs, génératrices et transformateurs électriques et de matériel de distribution et de commande électrique',
            value: 'Fabrication de moteurs, génératrices et transformateurs électriques et de matériel de distribution et de commande électrique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de moteurs, génératrices et transformateurs électriques',
                value: 'Fabrication de moteurs, génératrices et transformateurs électriques',
              },
              { 
                default: 0,
                name: 'Fabrication de matériel de distribution et de commande électrique',
                value: 'Fabrication de matériel de distribution et de commande électrique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de piles et d\'accumulateurs électriques',
            value: 'Fabrication de piles et d\'accumulateurs électriques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de piles et d\'accumulateurs électriques',
                value: 'Fabrication de piles et d\'accumulateurs électriques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de fils et câbles et de matériel d\'installation électrique',
            value: 'Fabrication de fils et câbles et de matériel d\'installation électrique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de câbles de fibres optiques',
                value: 'Fabrication de câbles de fibres optiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres fils et câbles électroniques ou électriques',
                value: 'Fabrication d\'autres fils et câbles électroniques ou électriques',
              },
              { 
                default: 0,
                name: 'Fabrication de matériel d\'installation électrique',
                value: 'Fabrication de matériel d\'installation électrique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'appareils d\'éclairage électrique',
            value: 'Fabrication d\'appareils d\'éclairage électrique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'appareils d\'éclairage électrique',
                value: 'Fabrication d\'appareils d\'éclairage électrique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'appareils ménagers',
            value: 'Fabrication d\'appareils ménagers',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'appareils électroménagers',
                value: 'Fabrication d\'appareils électroménagers',
              },
              { 
                default: 0,
                name: 'Fabrication d\'appareils ménagers non électriques',
                value: 'Fabrication d\'appareils ménagers non électriques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres matériels électriques',
            value: 'Fabrication d\'autres matériels électriques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'autres matériels électriques',
                value: 'Fabrication d\'autres matériels électriques',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication de machines et équipements n.c.a.',
        value: 'Fabrication de machines et équipements n.c.a.',
        groups: [
          {
            default: 0,
            name: 'Fabrication de machines d\'usage général',
            value: 'Fabrication de machines d\'usage général',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de moteurs et turbines, à l\'exception des moteurs d\'avions et de véhicules',
                value: 'Fabrication de moteurs et turbines, à l\'exception des moteurs d\'avions et de véhicules',
              },
              { 
                default: 0,
                name: 'Fabrication d\'équipements hydrauliques et pneumatiques',
                value: 'Fabrication d\'équipements hydrauliques et pneumatiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres pompes et compresseurs',
                value: 'Fabrication d\'autres pompes et compresseurs',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres articles de robinetterie',
                value: 'Fabrication d\'autres articles de robinetterie',
              },
              { 
                default: 0,
                name: 'Fabrication d\'engrenages et d\'organes mécaniques de transmission',
                value: 'Fabrication d\'engrenages et d\'organes mécaniques de transmission',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres machines d\'usage général',
            value: 'Fabrication d\'autres machines d\'usage général',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de fours et brûleurs',
                value: 'Fabrication de fours et brûleurs',
              },
              { 
                default: 0,
                name: 'Fabrication de matériel de levage et de manutention',
                value: 'Fabrication de matériel de levage et de manutention',
              },
              { 
                default: 0,
                name: 'Fabrication de machines et d\'équipements de bureau (à l\'exception des ordinateurs etéquipements périphériques)',
                value: 'Fabrication de machines et d\'équipements de bureau (à l\'exception des ordinateurs etéquipements périphériques)',
              },
              { 
                default: 0,
                name: 'Fabrication d\'outillage portatif à moteur incorporé',
                value: 'Fabrication d\'outillage portatif à moteur incorporé',
              },
              { 
                default: 0,
                name: 'Fabrication d\'équipements aérauliques et frigorifiques industriels',
                value: 'Fabrication d\'équipements aérauliques et frigorifiques industriels',
              },
              { 
                default: 0,
                name: 'Fabrication de machines diverses d\'usage général',
                value: 'Fabrication de machines diverses d\'usage général',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de machines agricoles et forestières',
            value: 'Fabrication de machines agricoles et forestières',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de machines agricoles et forestières',
                value: 'Fabrication de machines agricoles et forestières',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de machines de formage des métaux et de machines-outils',
            value: 'Fabrication de machines de formage des métaux et de machines-outils',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de machines de formage des métaux',
                value: 'Fabrication de machines de formage des métaux',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres machines-outils',
                value: 'Fabrication d\'autres machines-outils',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'autres machines d\'usage spécifique',
            value: 'Fabrication d\'autres machines d\'usage spécifique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de machines pour la métallurgie',
                value: 'Fabrication de machines pour la métallurgie',
              },
              { 
                default: 0,
                name: 'Fabrication de machines pour l\'extraction ou la construction',
                value: 'Fabrication de machines pour l\'extraction ou la construction',
              },
              { 
                default: 0,
                name: 'Fabrication de machines pour l\'industrie agro-alimentaire',
                value: 'Fabrication de machines pour l\'industrie agro-alimentaire',
              },
              { 
                default: 0,
                name: 'Fabrication de machines pour les industries textiles',
                value: 'Fabrication de machines pour les industries textiles',
              },
              { 
                default: 0,
                name: 'Fabrication de machines pour les industries du papier et du carton',
                value: 'Fabrication de machines pour les industries du papier et du carton',
              },
              { 
                default: 0,
                name: 'Fabrication de machines pour le travail du caoutchouc ou des plastiques',
                value: 'Fabrication de machines pour le travail du caoutchouc ou des plastiques',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres machines d\'usage spécifique n.c.a.',
                value: 'Fabrication d\'autres machines d\'usage spécifique n.c.a.',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Industrie automobile',
        value: 'Industrie automobile',
        groups: [
          {
            default: 0,
            name: 'Construction de véhicules automobiles',
            value: 'Construction de véhicules automobiles',
            classes: [
              { 
                default: 0,
                name: 'Construction de véhicules automobiles',
                value: 'Construction de véhicules automobiles',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de carrosseries et remorques',
            value: 'Fabrication de carrosseries et remorques',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de carrosseries et remorques',
                value: 'Fabrication de carrosseries et remorques',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'équipements automobiles',
            value: 'Fabrication d\'équipements automobiles',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'équipements électriques et électroniques automobiles',
                value: 'Fabrication d\'équipements électriques et électroniques automobiles',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres équipements automobiles',
                value: 'Fabrication d\'autres équipements automobiles',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Fabrication d\'autres matériels de transport',
        value: 'Fabrication d\'autres matériels de transport',
        groups: [
          {
            default: 0,
            name: 'Construction navale',
            value: 'Construction navale',
            classes: [
              { 
                default: 0,
                name: 'Construction de navires et de structures flottantes',
                value: 'Construction de navires et de structures flottantes',
              },
              { 
                default: 0,
                name: 'Construction de bateaux de plaisance',
                value: 'Construction de bateaux de plaisance',
              }
            ]
          },
          {
            default: 0,
            name: 'Construction de locomotives et d\'autre matériel ferroviaire roulant',
            value: 'Construction de locomotives et d\'autre matériel ferroviaire roulant',
            classes: [
              { 
                default: 0,
                name: 'Construction de locomotives et d\'autre matériel ferroviaire roulant',
                value: 'Construction de locomotives et d\'autre matériel ferroviaire roulant',
              }
            ]
          },
          {
            default: 0,
            name: 'Construction aéronautique et spatiale',
            value: 'Construction aéronautique et spatiale',
            classes: [
              { 
                default: 0,
                name: 'Construction aéronautique et spatiale',
                value: 'Construction aéronautique et spatiale',
              }
            ]
          },
          {
            default: 0,
            name: 'Construction de véhicules militaires de combat',
            value: 'Construction de véhicules militaires de combat',
            classes: [
              { 
                default: 0,
                name: 'Construction de véhicules militaires de combat',
                value: 'Construction de véhicules militaires de combat',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de matériels de transport n.c.a.',
            value: 'Fabrication de matériels de transport n.c.a.',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de motocycles',
                value: 'Fabrication de motocycles',
              },
              { 
                default: 0,
                name: 'Fabrication de bicyclettes et de véhicules pour invalides',
                value: 'Fabrication de bicyclettes et de véhicules pour invalides',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres équipements de transport n.c.a.',
                value: 'Fabrication d\'autres équipements de transport n.c.a.',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Fabrication de meubles',
        value: 'Fabrication de meubles',
        groups: [
          {
            default: 0,
            name: 'Fabrication de meubles',
            value: 'Fabrication de meubles',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de meubles de bureau et de magasin',
                value: 'Fabrication de meubles de bureau et de magasin',
              },
              { 
                default: 0,
                name: 'Fabrication de meubles de cuisine',
                value: 'Fabrication de meubles de cuisine',
              },
              { 
                default: 0,
                name: 'Fabrication de matelas',
                value: 'Fabrication de matelas',
              },
              { 
                default: 0,
                name: 'Industries connexes de l\'ameublement',
                value: 'Industries connexes de l\'ameublement',
              },
              { 
                default: 0,
                name: 'Fabrication d\'autres meubles',
                value: 'Fabrication d\'autres meubles',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Autres industries manufacturières',
        value: 'Autres industries manufacturières',
        groups: [
          {
            default: 0,
            name: 'Fabrication d\'articles de joaillerie, bijouterie et articles similaires',
            value: 'Fabrication d\'articles de joaillerie, bijouterie et articles similaires',
            classes: [
              { 
                default: 0,
                name: 'Frappe de monnaie',
                value: 'Frappe de monnaie',
              },
              { 
                default: 0,
                name: 'Fabrication d\'articles de joaillerie et bijouterie',
                value: 'Fabrication d\'articles de joaillerie et bijouterie',
              },
              { 
                default: 0,
                name: 'Fabrication d\'articles de bijouterie fantaisie et articles similaires',
                value: 'Fabrication d\'articles de bijouterie fantaisie et articles similaires',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'instruments de musique',
            value: 'Fabrication d\'instruments de musique',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'instruments de musique',
                value: 'Fabrication d\'instruments de musique',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'articles de sport',
            value: 'Fabrication d\'articles de sport',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'articles de sport',
                value: 'Fabrication d\'articles de sport',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication de jeux et jouets',
            value: 'Fabrication de jeux et jouets',
            classes: [
              { 
                default: 0,
                name: 'Fabrication de jeux et jouets',
                value: 'Fabrication de jeux et jouets',
              }
            ]
          },
          {
            default: 0,
            name: 'Fabrication d\'instruments et de fournitures à usage médical et dentaire',
            value: 'Fabrication d\'instruments et de fournitures à usage médical et dentaire',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'instruments et de fournitures à usage médical et dentaire',
                value: 'Fabrication d\'instruments et de fournitures à usage médical et dentaire',
              }
            ]
          },
          {
            default: 0,
            name: 'Activités manufacturières n.c.a.',
            value: 'Activités manufacturières n.c.a.',
            classes: [
              { 
                default: 0,
                name: 'Fabrication d\'articles de brosserie',
                value: 'Fabrication d\'articles de brosserie',
              },
              { 
                default: 0,
                name: 'Autres activités manufacturières n.c.a.',
                value: 'Autres activités manufacturières n.c.a.',
              }
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Réparation et installation de machines et d\'équipements',
        value: 'Réparation et installation de machines et d\'équipements',
        groups: [
          {
            default: 0,
            name: 'Réparation d\'ouvrages en métaux, de machines et d\'équipements',
            value: 'Réparation d\'ouvrages en métaux, de machines et d\'équipements',
            classes: [
              { 
                default: 0,
                name: 'Réparation d\'ouvrages en métaux',
                value: 'Réparation d\'ouvrages en métaux',
              },
              { 
                default: 0,
                name: 'Réparation de machines et équipements mécaniques',
                value: 'Réparation de machines et équipements mécaniques',
              },
              { 
                default: 0,
                name: 'Réparation de matériels électroniques et optiques',
                value: 'Réparation de matériels électroniques et optiques',
              },
              { 
                default: 0,
                name: 'Réparation d\'équipements électriques',
                value: 'Réparation d\'équipements électriques',
              },
              { 
                default: 0,
                name: 'Réparation et maintenance navale',
                value: 'Réparation et maintenance navale',
              },
              { 
                default: 0,
                name: 'Réparation et maintenance d\'aéronefs et d\'engins spatiaux',
                value: 'Réparation et maintenance d\'aéronefs et d\'engins spatiaux',
              },
              { 
                default: 0,
                name: 'Réparation et maintenance d\'autres équipements de transport',
                value: 'Réparation et maintenance d\'autres équipements de transport',
              },
              { 
                default: 0,
                name: 'Réparation d\'autres équipements',
                value: 'Réparation d\'autres équipements',
              }
            ]
          },
          {
            default: 0,
            name: 'Installation de machines et d\'équipements industriels',
            value: 'Installation de machines et d\'équipements industriels',
            classes: [
              { 
                default: 0,
                name: 'Installation de machines et d\'équipements industriels',
                value: 'Installation de machines et d\'équipements industriels',
              }
            ]
          }
        ]
      },
    ]
  },
  {
    default: 0,
    name: 'PRODUCTION ET DISTRIBUTION D\'ÉLECTRICITÉ, DE GAZ, DE VAPEURD ET D\'AIR CONDITIONNÉ',
    value: 'PRODUCTION ET DISTRIBUTION D\'ÉLECTRICITÉ, DE GAZ, DE VAPEURD ET D\'AIR CONDITIONNÉ',
    divisions: [
      {
        default: 0,
        name: 'Production et distribution d\'électricité, de gaz, de vapeur et d\'air conditionné',
        value: 'Production et distribution d\'électricité, de gaz, de vapeur et d\'air conditionné',
        groups: [
          {
            default: 0,
            name: 'Production, transport et distribution d\'électricité',
            value: 'Production, transport et distribution d\'électricité',
            classes: [
              { 
                default: 0,
                name: 'Production d\'électricité',
                value: 'Production d\'électricité',
              },
              { 
                default: 0,
                name: 'Transport d\'électricité',
                value: 'Transport d\'électricité',
              },
              { 
                default: 0,
                name: 'Distribution d\'électricité',
                value: 'Distribution d\'électricité',
              },
              { 
                default: 0,
                name: 'Commerce d\'électricité',
                value: 'Commerce d\'électricité',
              }            
            ]
          },
          {
            default: 0,
            name: 'Production et distribution de combustibles gazeux',
            value: 'Production et distribution de combustibles gazeux',
            classes: [
              { 
                default: 0,
                name: 'Production de combustibles gazeux',
                value: 'Production de combustibles gazeux',
              },
              { 
                default: 0,
                name: 'Distribution de combustibles gazeux par conduites',
                value: 'Distribution de combustibles gazeux par conduites',
              },
              { 
                default: 0,
                name: 'Commerce de combustibles gazeux par conduites',
                value: 'Commerce de combustibles gazeux par conduites',
              }               
            ]
          },
          {
            default: 0,
            name: 'Production et distribution de vapeur et d\'air conditionné',
            value: 'Production et distribution de vapeur et d\'air conditionné',
            classes: [
              { 
                default: 0,
                name: 'Production et distribution de vapeur et d\'air conditionné',
                value: 'Production et distribution de vapeur et d\'air conditionné',
              }              
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'PRODUCTION ET DISTRIBUTION D\'EAU; ASSAINISSEMENT, GESTION DES DÉCHETS ET DÉPOLLUTION',
    value: 'PRODUCTION ET DISTRIBUTION D\'EAU; ASSAINISSEMENT, GESTION DES DÉCHETS ET DÉPOLLUTION',
    divisions: [
      {
        default: 0,
        name: 'Captage, traitement et distribution d\'eau',
        value: 'Captage, traitement et distribution d\'eau',
        groups: [
          {
            default: 0,
            name: 'Captage, traitement et distribution d\'eau',
            value: 'Captage, traitement et distribution d\'eau',
            classes: [
              { 
                default: 0,
                name: 'Captage, traitement et distribution d\'eau',
                value: 'Captage, traitement et distribution d\'eau',
              }         
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Collecte et traitement des eaux usées',
        value: 'Collecte et traitement des eaux usées',
        groups: [
          {
            default: 0,
            name: 'Collecte et traitement des eaux usées',
            value: 'Collecte et traitement des eaux usées',
            classes: [
              { 
                default: 0,
                name: 'Collecte et traitement des eaux usées',
                value: 'Collecte et traitement des eaux usées',
              }         
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Collecte, traitement et élimination des déchets; récupération',
        value: 'Collecte, traitement et élimination des déchets; récupération',
        groups: [
          {
            default: 0,
            name: 'Collecte des déchets',
            value: 'Collecte des déchets',
            classes: [
              { 
                default: 0,
                name: 'Collecte des déchets non dangereux',
                value: 'Collecte des déchets non dangereux',
              },
              { 
                default: 0,
                name: 'Collecte des déchets dangereux',
                value: 'Collecte des déchets dangereux',
              }      
            ]
          },
          {
            default: 0,
            name: 'Traitement et élimination des déchets',
            value: 'Traitement et élimination des déchets',
            classes: [
              { 
                default: 0,
                name: 'Traitement et élimination des déchets non dangereux',
                value: 'Traitement et élimination des déchets non dangereux',
              },
              { 
                default: 0,
                name: 'Traitement et élimination des déchets dangereux',
                value: 'Traitement et élimination des déchets dangereux',
              }      
            ]
          },
          {
            default: 0,
            name: 'Récupération',
            value: 'Récupération',
            classes: [
              { 
                default: 0,
                name: 'Démantèlement d\'épaves',
                value: 'Démantèlement d\'épaves',
              },
              { 
                default: 0,
                name: 'Récupération de déchets triés',
                value: 'Récupération de déchets triés',
              }      
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Dépollution et autres services de gestion des déchets',
        value: 'Dépollution et autres services de gestion des déchets',
        groups: [
          {
            default: 0,
            name: 'Dépollution et autres services de gestion des déchets',
            value: 'Dépollution et autres services de gestion des déchets',
            classes: [
              { 
                default: 0,
                name: 'Dépollution et autres services de gestion des déchets',
                value: 'Dépollution et autres services de gestion des déchets',
              }         
            ]
          }
        ]
      },
    ]
  },
  {
    default: 0,
    name: 'CONSTRUCTION',
    value: 'CONSTRUCTION',
    divisions: [
      {
        default: 0,
        name: 'Construction de bâtiments',
        value: 'Construction de bâtiments',
        groups: [
          {
            default: 0,
            name: 'Promotion immobilière',
            value: 'Promotion immobilière',
            classes: [
              { 
                default: 0,
                name: 'Promotion immobilière',
                value: 'Promotion immobilière',
              }         
            ]
          },
          {
            default: 0,
            name: 'Construction de bâtiments résidentiels et non résidentiels',
            value: 'Construction de bâtiments résidentiels et non résidentiels',
            classes: [
              { 
                default: 0,
                name: 'Construction de bâtiments résidentiels et non résidentiels',
                value: 'Construction de bâtiments résidentiels et non résidentiels',
              }         
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Génie civil',
        value: 'Génie civil',
        groups: [
          {
            default: 0,
            name: 'Construction de routes et de voies ferrées',
            value: 'Construction de routes et de voies ferrées',
            classes: [
              { 
                default: 0,
                name: 'Construction de routes et autoroutes',
                value: 'Construction de routes et autoroutes',
              },
              { 
                default: 0,
                name: 'Construction de voies ferrées',
                value: 'Construction de voies ferrées',
              },
              { 
                default: 0,
                name: 'Construction de ponts et tunnels',
                value: 'Construction de ponts et tunnels',
              }         
            ]
          },
          {
            default: 0,
            name: 'Construction de réseaux et de lignes',
            value: 'Construction de réseaux et de lignes',
            classes: [
              { 
                default: 0,
                name: 'Construction de réseaux pour fluides',
                value: 'Construction de réseaux pour fluides',
              },
              { 
                default: 0,
                name: 'Construction de réseaux électriques et de télécommunications',
                value: 'Construction de réseaux électriques et de télécommunications',
              }        
            ]
          },
          {
            default: 0,
            name: 'Construction d\'autres ouvrages de génie civil',
            value: 'Construction d\'autres ouvrages de génie civil',
            classes: [
              { 
                default: 0,
                name: 'Construction d\'ouvrages maritimes et fluviaux',
                value: 'Construction d\'ouvrages maritimes et fluviaux',
              },
              { 
                default: 0,
                name: 'Construction d\'autres ouvrages de génie civil n.c.a.',
                value: 'Construction d\'autres ouvrages de génie civil n.c.a.',
              }      
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Travaux de construction spécialisés',
        value: 'Travaux de construction spécialisés',
        groups: [
          {
            default: 0,
            name: 'Démolition et préparation des sites',
            value: 'Démolition et préparation des sites',
            classes: [
              { 
                default: 0,
                name: 'Travaux de démolition',
                value: 'Travaux de démolition',
              },
              { 
                default: 0,
                name: 'Travaux de préparation des sites',
                value: 'Travaux de préparation des sites',
              },
              { 
                default: 0,
                name: 'Forages et sondages',
                value: 'Forages et sondages',
              }    
            ]
          },
          {
            default: 0,
            name: 'Travaux d\'installation électrique, plomberie et autres travaux d\'installation',
            value: 'Travaux d\'installation électrique, plomberie et autres travaux d\'installation',
            classes: [
              { 
                default: 0,
                name: 'Installation électrique',
                value: 'Installation électrique',
              },
              { 
                default: 0,
                name: 'Travaux de plomberie et installation de chauffage et de conditionnement d\'air',
                value: 'Travaux de plomberie et installation de chauffage et de conditionnement d\'air',
              },
              { 
                default: 0,
                name: 'Autres travaux d\'installation',
                value: 'Autres travaux d\'installation',
              }      
            ]
          },
          {
            default: 0,
            name: 'Travaux de finition',
            value: 'Travaux de finition',
            classes: [
              { 
                default: 0,
                name: 'Travaux de plâtrerie',
                value: 'Travaux de plâtrerie',
              },
              { 
                default: 0,
                name: 'Travaux de menuiserie',
                value: 'Travaux de menuiserie',
              },
              { 
                default: 0,
                name: 'Travaux de revêtement des sols et des murs',
                value: 'Travaux de revêtement des sols et des murs',
              },
              { 
                default: 0,
                name: 'Travaux de miroiterie de bâtiments; vitrerie',
                value: 'Travaux de miroiterie de bâtiments; vitrerie',
              },
              { 
                default: 0,
                name: 'Travaux de peinture',
                value: 'Travaux de peinture',
              },
              { 
                default: 0,
                name: 'Autres travaux de finition',
                value: 'Autres travaux de finition',
              }    
            ]
          },
          {
            default: 0,
            name: 'Autres travaux de construction spécialisés',
            value: 'Autres travaux de construction spécialisés',
            classes: [
              { 
                default: 0,
                name: 'Travaux de couverture',
                value: 'Travaux de couverture',
              },
              { 
                default: 0,
                name: 'Autres travaux de construction spécialisés n.c.a.',
                value: 'Autres travaux de construction spécialisés n.c.a.',
              }        
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'COMMERCE; RÉPARATION D\'AUTOMOBILES ET DE MOTOCYCLES',
    value: 'COMMERCE; RÉPARATION D\'AUTOMOBILES ET DE MOTOCYCLES',
    divisions: [
      {
        default: 0,
        name: 'Commerce et réparation d\'automobiles et de motocycles',
        value: 'Commerce et réparation d\'automobiles et de motocycles',
        groups: [
          {
            default: 0,
            name: 'Commerce de véhicules automobiles',
            value: 'Commerce de véhicules automobiles',
            classes: [
              { 
                default: 0,
                name: 'Commerce de voitures et de véhicules automobiles légers',
                value: 'Commerce de voitures et de véhicules automobiles légers',
              },
              { 
                default: 0,
                name: 'Commerce d\'autres véhicules automobiles',
                value: 'Commerce d\'autres véhicules automobiles',
              }       
            ]
          },
          {
            default: 0,
            name: 'Entretien et réparation de véhicules automobiles',
            value: 'Entretien et réparation de véhicules automobiles',
            classes: [
              { 
                default: 0,
                name: 'Entretien et réparation de véhicules automobiles',
                value: 'Entretien et réparation de véhicules automobiles',
              }         
            ]
          },
          {
            default: 0,
            name: 'Commerce d\'équipements automobiles',
            value: 'Commerce d\'équipements automobiles',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros d\'équipements automobiles',
                value: 'Commerce de gros d\'équipements automobiles',
              },
              { 
                default: 0,
                name: 'Commerce de détail d\'équipements automobiles',
                value: 'Commerce de détail d\'équipements automobiles',
              }        
            ]
          },
          {
            default: 0,
            name: 'Commerce et réparation de motocycles',
            value: 'Commerce et réparation de motocycles',
            classes: [
              { 
                default: 0,
                name: 'Commerce de motocycles',
                value: 'Commerce de motocycles',
              },
              { 
                default: 0,
                name: 'Réparation de motocycles',
                value: 'Réparation de motocycles',
              }        
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Commerce de gros, à l’exception des automobiles et des motocycles',
        value: 'Commerce de gros, à l’exception des automobiles et des motocycles',
        groups: [
          {
            default: 0,
            name: 'Intermédiaires du commerce de gros',
            value: 'Intermédiaires du commerce de gros',
            classes: [
              { 
                default: 0,
                name: 'Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
                value: 'Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis',
              },
              { 
                default: 0,
                name: 'Intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques',
                value: 'Intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques',
              },
              { 
                default: 0,
                name: 'Intermédiaires du commerce en bois et matériaux de construction',
                value: 'Intermédiaires du commerce en bois et matériaux de construction',
              },
              { 
                default: 0,
                name: 'Intermédiaires du commerce en machines, équipements industriels, navires et avions',
                value: 'Intermédiaires du commerce en machines, équipements industriels, navires et avions',
              },
              { 
                default: 0,
                name: 'Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir',
                value: 'Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir',
              },
              { 
                default: 0,
                name: 'Intermédiaires du commerce en denrées, boissons et tabac',
                value: 'Intermédiaires du commerce en denrées, boissons et tabac',
              },
              { 
                default: 0,
                name: 'Intermédiaires spécialisés dans le commerce d\'autres produits spécifiques',
                value: 'Intermédiaires spécialisés dans le commerce d\'autres produits spécifiques',
              },
              { 
                default: 0,
                name: 'Intermédiaires du commerce en produits divers',
                value: 'Intermédiaires du commerce en produits divers',
              }
            ]
          },
          {
            default: 0,
            name: 'Commerce de gros de produits agricoles bruts et d\'animaux vivants',
            value: 'Commerce de gros de produits agricoles bruts et d\'animaux vivants',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros de céréales, de tabac non manufacturé, de semences et d\'aliments pour le bétail',
                value: 'Commerce de gros de céréales, de tabac non manufacturé, de semences et d\'aliments pour le bétail',
              },
              { 
                default: 0,
                name: 'Commerce de gros de fleurs et plantes',
                value: 'Commerce de gros de fleurs et plantes',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'animaux vivants',
                value: 'Commerce de gros d\'animaux vivants',
              },
              { 
                default: 0,
                name: 'Commerce de gros de cuirs et peaux',
                value: 'Commerce de gros de cuirs et peaux',
              }      
            ]
          },
          {
            default: 0,
            name: 'Commerce de gros de produits alimentaires, de boissons et de tabac',
            value: 'Commerce de gros de produits alimentaires, de boissons et de tabac',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros de fruits et légumes',
                value: 'Commerce de gros de fruits et légumes',
              },
              { 
                default: 0,
                name: 'Commerce de gros de viandes et de produits à base de viande',
                value: 'Commerce de gros de viandes et de produits à base de viande',
              },
              { 
                default: 0,
                name: 'Commerce de gros de produits laitiers, œufs, huiles et matières grasses comestibles',
                value: 'Commerce de gros de produits laitiers, œufs, huiles et matières grasses comestibles',
              },
              { 
                default: 0,
                name: 'Commerce de gros de boissons',
                value: 'Commerce de gros de boissons',
              },
              { 
                default: 0,
                name: 'Commerce de gros de produits à base de tabac',
                value: 'Commerce de gros de produits à base de tabac',
              },
              { 
                default: 0,
                name: 'Commerce de gros de sucre, chocolat et confiserie, de café, thé, cacao et épices',
                value: 'Commerce de gros de sucre, chocolat et confiserie, de café, thé, cacao et épices',
              },
              { 
                default: 0,
                name: 'Commerce de gros de poissons, crustacés et mollusques',
                value: 'Commerce de gros de poissons, crustacés et mollusques',
              },
              { 
                default: 0,
                name: 'Commerce de gros spécialisé d\'autres produits alimentaires',
                value: 'Commerce de gros spécialisé d\'autres produits alimentaires',
              },
              { 
                default: 0,
                name: 'Commerce de gros non spécialisé de denrées alimentaires, de boissons et de tabac',
                value: 'Commerce de gros non spécialisé de denrées alimentaires, de boissons et de tabac',
              }  
            ]
          },
          {
            default: 0,
            name: 'Commerce de gros de biens domestiques',
            value: 'Commerce de gros de biens domestiques',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros de textiles',
                value: 'Commerce de gros de textiles',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'habillement et de chaussures',
                value: 'Commerce de gros d\'habillement et de chaussures',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'appareils électroménagers',
                value: 'Commerce de gros d\'appareils électroménagers',
              },
              { 
                default: 0,
                name: 'Commerce de gros de vaisselle, verrerie et produits d\'entretien',
                value: 'Commerce de gros de vaisselle, verrerie et produits d\'entretien',
              },
              { 
                default: 0,
                name: 'Commerce de gros de parfumerie et de produits de beauté',
                value: 'Commerce de gros de parfumerie et de produits de beauté',
              },
              { 
                default: 0,
                name: 'Commerce de gros de produits pharmaceutiques',
                value: 'Commerce de gros de produits pharmaceutiques',
              },
              { 
                default: 0,
                name: 'Commerce de gros de meubles, de tapis et d\'appareils d\'éclairage',
                value: 'Commerce de gros de meubles, de tapis et d\'appareils d\'éclairage',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'articles d\'horlogerie et de bijouterie',
                value: 'Commerce de gros d\'articles d\'horlogerie et de bijouterie',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'autres biens domestiques',
                value: 'Commerce de gros d\'autres biens domestiques',
              }  
            ]
          },
          {
            default: 0,
            name: 'Commerce de gros d\'équipements de l\'information et de la communication',
            value: 'Commerce de gros d\'équipements de l\'information et de la communication',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros d\'ordinateurs, d\'équipements informatiques périphériques et de logiciels',
                value: 'Commerce de gros d\'ordinateurs, d\'équipements informatiques périphériques et de logiciels',
              },
              { 
                default: 0,
                name: 'Commerce de gros de composants et d\'équipements électroniques et de télécommunication',
                value: 'Commerce de gros de composants et d\'équipements électroniques et de télécommunication',
              }  
            ]
          },
          {
            default: 0,
            name: 'Commerce de gros d\'autres équipements industriels',
            value: 'Commerce de gros d\'autres équipements industriels',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros de matériel agricole',
                value: 'Commerce de gros de matériel agricole',
              },
              { 
                default: 0,
                name: 'Commerce de gros de machines-outils',
                value: 'Commerce de gros de machines-outils',
              },
              { 
                default: 0,
                name: 'Commerce de gros de machines pour l\'extraction, la construction et le génie civil',
                value: 'Commerce de gros de machines pour l\'extraction, la construction et le génie civil',
              },
              { 
                default: 0,
                name: 'Commerce de gros de machines pour l\'industrie textile et l\'habillement',
                value: 'Commerce de gros de machines pour l\'industrie textile et l\'habillement',
              },
              { 
                default: 0,
                name: 'Commerce de gros de mobilier de bureau',
                value: 'Commerce de gros de mobilier de bureau',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'autres machines et équipements de bureau',
                value: 'Commerce de gros d\'autres machines et équipements de bureau',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'autres matériels électriques',
                value: 'Commerce de gros d\'autres matériels électriques',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'autres machines et équipements',
                value: 'Commerce de gros d\'autres machines et équipements',
              }
            ]
          },
          {
            default: 0,
            name: 'Autres commerces de gros spécialisés',
            value: 'Autres commerces de gros spécialisés',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros de combustibles et de produits annexes',
                value: 'Commerce de gros de combustibles et de produits annexes',
              },
              { 
                default: 0,
                name: 'Commerce de gros de minerais et métaux',
                value: 'Commerce de gros de minerais et métaux',
              },
              { 
                default: 0,
                name: 'Commerce de gros de bois et de produits dérivés',
                value: 'Commerce de gros de bois et de produits dérivés',
              },
              { 
                default: 0,
                name: 'Commerce de gros de matériaux de construction et d\'appareils sanitaires',
                value: 'Commerce de gros de matériaux de construction et d\'appareils sanitaires',
              },
              { 
                default: 0,
                name: 'Commerce de gros de quincaillerie et fournitures pour plomberie et chauffage',
                value: 'Commerce de gros de quincaillerie et fournitures pour plomberie et chauffage',
              },
              { 
                default: 0,
                name: 'Commerce de gros de produits chimiques',
                value: 'Commerce de gros de produits chimiques',
              },
              { 
                default: 0,
                name: 'Commerce de gros d\'autres produits intermédiaires',
                value: 'Commerce de gros d\'autres produits intermédiaires',
              },
              { 
                default: 0,
                name: 'Commerce de gros de déchets et débris',
                value: 'Commerce de gros de déchets et débris',
              }
            ]
          },
          {
            default: 0,
            name: 'Commerce de gros non spécialisé',
            value: 'Commerce de gros non spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de gros non spécialisé',
                value: 'Commerce de gros non spécialisé',
              }        
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Commerce de détail, à l\'exception des automobiles et des motocycles',
        value: 'Commerce de détail, à l\'exception des automobiles et des motocycles',
        groups: [
          {
            default: 0,
            name: 'Commerce de détail en magasin non spécialisé',
            value: 'Commerce de détail en magasin non spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce d\'alimentation générale',
                value: 'Commerce d\'alimentation générale',
              },
              { 
                default: 0,
                name: 'Supérettes, supermarchés et hypermarchés',
                value: 'Supérettes, supermarchés et hypermarchés',
              },
              { 
                default: 0,
                name: 'Commerce de détail de produits divers de l\'artisanat',
                value: 'Commerce de détail de produits divers de l\'artisanat',
              },
              { 
                default: 0,
                name: 'Autre commerce de détail en magasin non spécialisé',
                value: 'Autre commerce de détail en magasin non spécialisé',
              }       
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail alimentaire en magasin spécialisé',
            value: 'Commerce de détail alimentaire en magasin spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail de fruits et légumes en magasin spécialisé',
                value: 'Commerce de détail de fruits et légumes en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de viandes et de produits à base de viande en magasin spécialisé',
                value: 'Commerce de détail de viandes et de produits à base de viande en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé',
                value: 'Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé',
                value: 'Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de boissons en magasin spécialisé',
                value: 'Commerce de détail de boissons en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de produits à base de tabac en magasin spécialisé',
                value: 'Commerce de détail de produits à base de tabac en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de produits laitiers',
                value: 'Commerce de détail de produits laitiers',
              },
              { 
                default: 0,
                name: 'Commerces de détail de grains, légumes secs et produits d\'épicerie',
                value: 'Commerces de détail de grains, légumes secs et produits d\'épicerie',
              },
              { 
                default: 0,
                name: 'Autres commerces de détail alimentaires en magasin spécialisé',
                value: 'Autres commerces de détail alimentaires en magasin spécialisé',
              }       
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail de carburants en magasin spécialisé',
            value: 'Commerce de détail de carburants en magasin spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail de carburants en magasin spécialisé',
                value: 'Commerce de détail de carburants en magasin spécialisé',
              }   
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail d\'équipements de l\'information et de la communication en magasin spécialisé',
            value: 'Commerce de détail d\'équipements de l\'information et de la communication en magasin spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail d\'ordinateurs, d\'unités périphériques et de logiciels en magasin spécialisé',
                value: 'Commerce de détail d\'ordinateurs, d\'unités périphériques et de logiciels en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de matériels de télécommunication en magasin spécialisé',
                value: 'Commerce de détail de matériels de télécommunication en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de matériels audio/vidéo en magasin spécialisé',
                value: 'Commerce de détail de matériels audio/vidéo en magasin spécialisé',
              }       
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail d\'autres équipements du foyer en magasin spécialisé',
            value: 'Commerce de détail d\'autres équipements du foyer en magasin spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail de textiles en magasin spécialisé',
                value: 'Commerce de détail de textiles en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de quincaillerie, peintures et verres en magasin spécialisé',
                value: 'Commerce de détail de quincaillerie, peintures et verres en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé',
                value: 'Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail d\'appareils électroménagers en magasin spécialisé',
                value: 'Commerce de détail d\'appareils électroménagers en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de meubles, appareils d\'éclairage et autres articles de ménage en magasin spécialisé',
                value: 'Commerce de détail de meubles, appareils d\'éclairage et autres articles de ménage en magasin spécialisé',
              }       
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail de biens culturels et de loisirs en magasin spécialisé',
            value: 'Commerce de détail de biens culturels et de loisirs en magasin spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail de livres en magasin spécialisé',
                value: 'Commerce de détail de livres en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de journaux et papeterie en magasin spécialisé',
                value: 'Commerce de détail de journaux et papeterie en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail d\'enregistrements musicaux et vidéo en magasin spécialisé',
                value: 'Commerce de détail d\'enregistrements musicaux et vidéo en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail d\'articles de sport en magasin spécialisé',
                value: 'Commerce de détail d\'articles de sport en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de jeux et jouets en magasin spécialisé',
                value: 'Commerce de détail de jeux et jouets en magasin spécialisé',
              }       
            ]
          },
          {
            default: 0,
            name: 'Autres commerces de détail en magasin spécialisé',
            value: 'Autres commerces de détail en magasin spécialisé',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail d\'habillement en magasin spécialisé',
                value: 'Commerce de détail d\'habillement en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de chaussures et d\'articles en cuir en magasin spécialisé',
                value: 'Commerce de détail de chaussures et d\'articles en cuir en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de produits pharmaceutiques en magasin spécialisé',
                value: 'Commerce de détail de produits pharmaceutiques en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail d\'articles médicaux et orthopédiques en magasin spécialisé',
                value: 'Commerce de détail d\'articles médicaux et orthopédiques en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé',
                value: 'Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé',
                value: 'Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail d\'articles d\'horlogerie et de bijouterie en magasin spécialisé',
                value: 'Commerce de détail d\'articles d\'horlogerie et de bijouterie en magasin spécialisé',
              },
              { 
                default: 0,
                name: 'Commerce de détail de charbon et combustibles',
                value: 'Commerce de détail de charbon et combustibles',
              },
              { 
                default: 0,
                name: 'Autres commerces de détail de biens neufs en magasin spécialisé',
                value: 'Autres commerces de détail de biens neufs en magasin spécialisé',
              }       
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail de biens neufs sur éventaires et marchés; Commerce de biens d\'occasion',
            value: 'Commerce de détail de biens neufs sur éventaires et marchés; Commerce de biens d\'occasion',
            classes: [
              { 
                default: 0,
                name: 'Commerce de détail alimentaire sur éventaires et marchés',
                value: 'Commerce de détail alimentaire sur éventaires et marchés',
              },
              { 
                default: 0,
                name: 'Commerce de détail de textiles, d\'habillement et de chaussures sur éventaires et marchés',
                value: 'Commerce de détail de textiles, d\'habillement et de chaussures sur éventaires et marchés',
              },
              { 
                default: 0,
                name: 'Autres commerces de détail sur éventaires et marchés',
                value: 'Autres commerces de détail sur éventaires et marchés',
              },
              { 
                default: 0,
                name: 'Commerce de détail de fripes',
                value: 'Commerce de détail de fripes',
              },
              { 
                default: 0,
                name: 'Commerce de détail de biens d\'antiquité et de brocante',
                value: 'Commerce de détail de biens d\'antiquité et de brocante',
              },
              { 
                default: 0,
                name: 'Autres commerces de détail de biens d\'occasion',
                value: 'Autres commerces de détail de biens d\'occasion',
              }      
            ]
          },
          {
            default: 0,
            name: 'Commerce de détail hors magasin, éventaires ou marchés',
            value: 'Commerce de détail hors magasin, éventaires ou marchés',
            classes: [
              { 
                default: 0,
                name: 'Vente à distance',
                value: 'Vente à distance',
              },
              { 
                default: 0,
                name: 'Autres commerces de détail hors magasin, éventaires ou marchés',
                value: 'Autres commerces de détail hors magasin, éventaires ou marchés',
              }   
            ]
          },
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'TRANSPORTS ET ENTREPOSAGE',
    value: 'TRANSPORTS ET ENTREPOSAGE',
    divisions: [
      {
        default: 0,
        name: 'Transports terrestres et transport par conduites',
        value: 'Transports terrestres et transport par conduites',
        groups: [
          {
            default: 0,
            name: 'Transport ferroviaire interurbain de voyageurs',
            value: 'Transport ferroviaire interurbain de voyageurs',
            classes: [
              { 
                default: 0,
                name: 'Transport ferroviaire interurbain de voyageurs',
                value: 'Transport ferroviaire interurbain de voyageurs',
              }         
            ]
          },
          {
            default: 0,
            name: 'Transports ferroviaires de fret',
            value: 'Transports ferroviaires de fret',
            classes: [
              { 
                default: 0,
                name: 'Transports ferroviaires de fret',
                value: 'Transports ferroviaires de fret',
              }         
            ]
          },
          {
            default: 0,
            name: 'Autres transports terrestres de voyageurs',
            value: 'Autres transports terrestres de voyageurs',
            classes: [
              { 
                default: 0,
                name: 'Transports urbains et suburbains de voyageurs',
                value: 'Transports urbains et suburbains de voyageurs',
              },
              { 
                default: 0,
                name: 'Transports de voyageurs par taxis et par louage',
                value: 'Transports de voyageurs par taxis et par louage',
              },
              { 
                default: 0,
                name: 'Autres transports terrestres réguliers de voyageurs, interurbain',
                value: 'Autres transports terrestres réguliers de voyageurs, interurbain',
              },
              { 
                default: 0,
                name: 'Autres transports terrestres de voyageurs n.c.a.',
                value: 'Autres transports terrestres de voyageurs n.c.a.',
              }         
            ]
          },
          {
            default: 0,
            name: 'Transports routiers de fret et services de déménagement',
            value: 'Transports routiers de fret et services de déménagement',
            classes: [
              { 
                default: 0,
                name: 'Transports routiers de fret',
                value: 'Transports routiers de fret',
              },
              { 
                default: 0,
                name: 'Services de déménagement',
                value: 'Services de déménagement',
              }         
            ]
          },
          {
            default: 0,
            name: 'Transports par conduites',
            value: 'Transports par conduites',
            classes: [
              { 
                default: 0,
                name: 'Transports par conduites',
                value: 'Transports par conduites',
              }       
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Transports par eau',
        value: 'Transports par eau',
        groups: [
          {
            default: 0,
            name: 'Transports maritimes et côtiers de passagers',
            value: 'Transports maritimes et côtiers de passagers',
            classes: [
              { 
                default: 0,
                name: 'Transports maritimes et côtiers de passagers',
                value: 'Transports maritimes et côtiers de passagers',
              }        
            ]
          },
          {
            default: 0,
            name: 'Transports maritimes et côtiers de fret',
            value: 'Transports maritimes et côtiers de fret',
            classes: [
              { 
                default: 0,
                name: 'Transports maritimes et côtiers de fret',
                value: 'Transports maritimes et côtiers de fret',
              }     
            ]
          },
          {
            default: 0,
            name: 'Transports fluviaux de passagers',
            value: 'Transports fluviaux de passagers',
            classes: [
              { 
                default: 0,
                name: 'Transports fluviaux de passagers',
                value: 'Transports fluviaux de passagers',
              }    
            ]
          },
          {
            default: 0,
            name: 'Transports fluviaux de fret',
            value: 'Transports fluviaux de fret',
            classes: [
              { 
                default: 0,
                name: 'Transports fluviaux de fret',
                value: 'Transports fluviaux de fret',
              }    
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Transports aériens',
        value: 'Transports aériens',
        groups: [
          {
            default: 0,
            name: 'Transports aériens de passagers',
            value: 'Transports aériens de passagers',
            classes: [
              { 
                default: 0,
                name: 'Transports aériens de passagers',
                value: 'Transports aériens de passagers',
              }        
            ]
          },
          {
            default: 0,
            name: 'Transports aériens de fret et transports spatiaux',
            value: 'Transports aériens de fret et transports spatiaux',
            classes: [
              { 
                default: 0,
                name: 'Transports aériens de fret',
                value: 'Transports aériens de fret',
              },
              { 
                default: 0,
                name: 'Transports spatiaux',
                value: 'Transports spatiaux',
              }      
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Entreposage et services auxiliaires des transports',
        value: 'Entreposage et services auxiliaires des transports',
        groups: [
          {
            default: 0,
            name: 'Entreposage et stockage',
            value: 'Entreposage et stockage',
            classes: [
              { 
                default: 0,
                name: 'Entreposage et stockage frigorifique',
                value: 'Entreposage et stockage frigorifique',
              },
              { 
                default: 0,
                name: 'Entreposage et stockage non frigorifique',
                value: 'Entreposage et stockage non frigorifique',
              }        
            ]
          },
          {
            default: 0,
            name: 'Services auxiliaires des transports',
            value: 'Services auxiliaires des transports',
            classes: [
              { 
                default: 0,
                name: 'Services auxiliaires des transports terrestres',
                value: 'Services auxiliaires des transports terrestres',
              },
              { 
                default: 0,
                name: 'Services auxiliaires des transports par eau',
                value: 'Services auxiliaires des transports par eau',
              },
              { 
                default: 0,
                name: 'Services auxiliaires des transports aériens',
                value: 'Services auxiliaires des transports aériens',
              },
              { 
                default: 0,
                name: 'Manutention',
                value: 'Manutention',
              },
              { 
                default: 0,
                name: 'Autres services auxiliaires des transports',
                value: 'Autres services auxiliaires des transports',
              }     
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités de poste et de courrier',
        value: 'Activités de poste et de courrier',
        groups: [
          {
            default: 0,
            name: 'Activités de poste dans le cadre d\'une obligation de service universel',
            value: 'Activités de poste dans le cadre d\'une obligation de service universel',
            classes: [
              { 
                default: 0,
                name: 'Activités de poste dans le cadre d\'une obligation de service universel',
                value: 'Activités de poste dans le cadre d\'une obligation de service universel',
              }     
            ]
          },
          {
            default: 0,
            name: 'Autres activités de poste et de courrier',
            value: 'Autres activités de poste et de courrier',
            classes: [
              { 
                default: 0,
                name: 'Autres activités de poste et de courrier',
                value: 'Autres activités de poste et de courrier',
              }    
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'HÉBERGEMENT ET RESTAURATION',
    value: 'HÉBERGEMENT ET RESTAURATION',
    divisions: [
      {
        default: 0,
        name: 'Hébergement',
        value: 'Hébergement',
        groups: [
          {
            default: 0,
            name: 'Hôtels et hébergement similaire',
            value: 'Hôtels et hébergement similaire',
            classes: [
              { 
                default: 0,
                name: 'Hôtels et hébergement similaire',
                value: 'Hôtels et hébergement similaire',
              }         
            ]
          },
          {
            default: 0,
            name: 'Hébergement touristique et autre hébergement de courte durée',
            value: 'Hébergement touristique et autre hébergement de courte durée',
            classes: [
              { 
                default: 0,
                name: 'Hébergement touristique et autre hébergement de courte durée',
                value: 'Hébergement touristique et autre hébergement de courte durée',
              }         
            ]
          },
          {
            default: 0,
            name: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
            value: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
            classes: [
              { 
                default: 0,
                name: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
                value: 'Terrains de camping et parcs pour caravanes ou véhicules de loisirs',
              }        
            ]
          },
          {
            default: 0,
            name: 'Autres hébergements',
            value: 'Autres hébergements',
            classes: [
              { 
                default: 0,
                name: 'Autres hébergements',
                value: 'Autres hébergements',
              }         
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Restauration',
        value: 'Restauration',
        groups: [
          {
            default: 0,
            name: 'Restaurants et services de restauration mobile',
            value: 'Restaurants et services de restauration mobile',
            classes: [
              { 
                default: 0,
                name: 'Restaurantion traditionnelle',
                value: 'Restaurantion traditionnelle',
              },
              { 
                default: 0,
                name: 'Restaurantion de type rapide',
                value: 'Restaurantion de type rapide',
              }        
            ]
          },
          {
            default: 0,
            name: 'Traiteurs et autres services de restauration',
            value: 'Traiteurs et autres services de restauration',
            classes: [
              { 
                default: 0,
                name: 'Services des traiteurs',
                value: 'Services des traiteurs',
              },
              { 
                default: 0,
                name: 'Autres services de restauration',
                value: 'Autres services de restauration',
              }    
            ]
          },
          {
            default: 0,
            name: 'Débits de boissons',
            value: 'Débits de boissons',
            classes: [
              { 
                default: 0,
                name: 'Cafés',
                value: 'Cafés',
              },
              { 
                default: 0,
                name: 'Débits de boissons alcoolisées',
                value: 'Débits de boissons alcoolisées',
              }   
            ]
          }
        ]
      },
    ]
  },
  {
    default: 0,
    name: 'INFORMATION ET COMMUNICATION',
    value: 'INFORMATION ET COMMUNICATION',
    divisions: [
      {
        default: 0,
        name: 'Édition',
        value: 'Édition',
        groups: [
          {
            default: 0,
            name: 'Édition de livres et périodiques et autres activités d\'édition',
            value: 'Édition de livres et périodiques et autres activités d\'édition',
            classes: [
              { 
                default: 0,
                name: 'Édition de livres',
                value: 'Édition de livres',
              },
              { 
                default: 0,
                name: 'Édition de répertoires et de fichiers d\'adresses',
                value: 'Édition de répertoires et de fichiers d\'adresses',
              },
              { 
                default: 0,
                name: 'Édition de journaux',
                value: 'Édition de journaux',
              },
              { 
                default: 0,
                name: 'Édition de revues et périodiques',
                value: 'Édition de revues et périodiques',
              },
              { 
                default: 0,
                name: 'Autres activités d\'édition',
                value: 'Autres activités d\'édition',
              }          
            ]
          },
          {
            default: 0,
            name: 'Édition de logiciels',
            value: 'Édition de logiciels',
            classes: [
              { 
                default: 0,
                name: 'Édition de jeux électroniques',
                value: 'Édition de jeux électroniques',
              },
              { 
                default: 0,
                name: 'Édition d\'autres logiciels',
                value: 'Édition d\'autres logiciels',
              }         
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Production de films cinématographiques, de vidéo et de programmes de télévision; enregistrement sonore et édition musicale',
        value: 'Production de films cinématographiques, de vidéo et de programmes de télévision; enregistrement sonore et édition musicale',
        groups: [
          {
            default: 0,
            name: 'Activités cinématographiques, vidéo et de télévision',
            value: 'Activités cinématographiques, vidéo et de télévision',
            classes: [
              { 
                default: 0,
                name: 'Production de films cinématographiques, de vidéo et de programmes de télévision',
                value: 'Production de films cinématographiques, de vidéo et de programmes de télévision',
              },
              { 
                default: 0,
                name: 'Post-production de films cinématographiques, de vidéo et de programmes de télévision',
                value: 'Post-production de films cinématographiques, de vidéo et de programmes de télévision',
              },
              { 
                default: 0,
                name: 'Distribution de films cinématographiques, de vidéo et de programmes de télévision',
                value: 'Distribution de films cinématographiques, de vidéo et de programmes de télévision',
              },
              { 
                default: 0,
                name: 'Projection de films cinématographiques',
                value: 'Projection de films cinématographiques',
              }        
            ]
          },
          {
            default: 0,
            name: 'Enregistrement sonore et édition musicale',
            value: 'Enregistrement sonore et édition musicale',
            classes: [
              { 
                default: 0,
                name: 'Enregistrement sonore et édition musicale',
                value: 'Enregistrement sonore et édition musicale',
              }   
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Programmation et diffusion',
        value: 'Programmation et diffusion',
        groups: [
          {
            default: 0,
            name: 'Édition et diffusion de programmes radio',
            value: 'Édition et diffusion de programmes radio',
            classes: [
              { 
                default: 0,
                name: 'Édition et diffusion de programmes radio',
                value: 'Édition et diffusion de programmes radio',
              }      
            ]
          },
          {
            default: 0,
            name: 'Programmation de télévision et télédiffusion',
            value: 'Programmation de télévision et télédiffusion',
            classes: [
              { 
                default: 0,
                name: 'Programmation de télévision et télédiffusion',
                value: 'Programmation de télévision et télédiffusion',
              }   
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Télécommunications',
        value: 'Télécommunications',
        groups: [
          {
            default: 0,
            name: 'Télécommunications filaires',
            value: 'Télécommunications filaires',
            classes: [
              { 
                default: 0,
                name: 'Télécommunications filaires',
                value: 'Télécommunications filaires',
              }      
            ]
          },
          {
            default: 0,
            name: 'Télécommunications sans fil',
            value: 'Télécommunications sans fil',
            classes: [
              { 
                default: 0,
                name: 'Télécommunications sans fil',
                value: 'Télécommunications sans fil',
              }   
            ]
          },
          {
            default: 0,
            name: 'Télécommunications par satellite',
            value: 'Télécommunications par satellite',
            classes: [
              { 
                default: 0,
                name: 'Télécommunications par satellite',
                value: 'Télécommunications par satellite',
              }      
            ]
          },
          {
            default: 0,
            name: 'Autres activités de télécommunication',
            value: 'Autres activités de télécommunication',
            classes: [
              { 
                default: 0,
                name: 'Autres activités de télécommunication',
                value: 'Autres activités de télécommunication',
              }   
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Programmation, conseil et autres activités informatiques',
        value: 'Programmation, conseil et autres activités informatiques',
        groups: [
          {
            default: 0,
            name: 'Programmation, conseil et autres activités informatiques',
            value: 'Programmation, conseil et autres activités informatiques',
            classes: [
              { 
                default: 0,
                name: 'Programmation informatique',
                value: 'Programmation informatique',
              },
              { 
                default: 0,
                name: 'Conseil informatique',
                value: 'Conseil informatique',
              },
              { 
                default: 0,
                name: 'Gestion d\'installations informatiques',
                value: 'Gestion d\'installations informatiques',
              },
              { 
                default: 0,
                name: 'Autres activités informatiques',
                value: 'Autres activités informatiques',
              }     
            ]
          },
        ]
      },
      {
        default: 0,
        name: 'Services d\'information',
        value: 'Services d\'information',
        groups: [
          {
            default: 0,
            name: 'Traitement de données, hébergement et activités connexes; portails Internet',
            value: 'Traitement de données, hébergement et activités connexes; portails Internet',
            classes: [
              { 
                default: 0,
                name: 'Traitement de données, hébergement et activités connexes',
                value: 'Traitement de données, hébergement et activités connexes',
              },
              { 
                default: 0,
                name: 'Portails Internet',
                value: 'Portails Internet',
              }    
            ]
          },
          {
            default: 0,
            name: 'Autres services d\'information',
            value: 'Autres services d\'information',
            classes: [
              { 
                default: 0,
                name: 'Activités des agences de presse',
                value: 'Activités des agences de presse',
              },
              { 
                default: 0,
                name: 'Autres services d\'information n.c.a.',
                value: 'Autres services d\'information n.c.a.',
              }    
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ACTIVITÉS FINANCIÈRES ET D\'ASSURANCE',
    value: 'ACTIVITÉS FINANCIÈRES ET D\'ASSURANCE',
    divisions: [
      {
        default: 0,
        name: 'Activités des services financiers, hors assurance et caisses de retraite',
        value: 'Activités des services financiers, hors assurance et caisses de retraite',
        groups: [
          {
            default: 0,
            name: 'Intermédiation monétaire',
            value: 'Intermédiation monétaire',
            classes: [
              { 
                default: 0,
                name: 'Activités de banque centrale',
                value: 'Activités de banque centrale',
              },
              { 
                default: 0,
                name: 'Autres intermédiations monétaires',
                value: 'Autres intermédiations monétaires',
              }       
            ]
          },
          {
            default: 0,
            name: 'Fonds de placement et entités financières similaires',
            value: 'Fonds de placement et entités financières similaires',
            classes: [
              { 
                default: 0,
                name: 'Fonds de placement et entités financières similaires',
                value: 'Fonds de placement et entités financières similaires',
              }        
            ]
          },
          {
            default: 0,
            name: 'Activités des sociétés holding',
            value: 'Activités des sociétés holding',
            classes: [
              { 
                default: 0,
                name: 'Activités des sociétés holding',
                value: 'Activités des sociétés holding',
              }        
            ]
          },
          {
            default: 0,
            name: 'Autres activités des services financiers, hors assurance et caisses de retraite',
            value: 'Autres activités des services financiers, hors assurance et caisses de retraite',
            classes: [
              { 
                default: 0,
                name: 'Crédit-bail',
                value: 'Crédit-bail',
              },
              { 
                default: 0,
                name: 'Autre distribution de crédit',
                value: 'Autre distribution de crédit',
              },
              { 
                default: 0,
                name: 'Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.',
                value: 'Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.',
              }        
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Assurance',
        value: 'Assurance',
        groups: [
          {
            default: 0,
            name: 'Assurance',
            value: 'Assurance',
            classes: [
              { 
                default: 0,
                name: 'Assurance vie',
                value: 'Assurance vie',
              },
              { 
                default: 0,
                name: 'Autres assurances',
                value: 'Autres assurances',
              }       
            ]
          },
          {
            default: 0,
            name: 'Réassurance',
            value: 'Réassurance',
            classes: [
              { 
                default: 0,
                name: 'Réassurance',
                value: 'Réassurance',
              }   
            ]
          },
          {
            default: 0,
            name: 'Caisses de retraite',
            value: 'Caisses de retraite',
            classes: [
              { 
                default: 0,
                name: 'Caisses de retraite',
                value: 'Caisses de retraite',
              }   
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités auxiliaires de services financiers et d\'assurance',
        value: 'Activités auxiliaires de services financiers et d\'assurance',
        groups: [
          {
            default: 0,
            name: 'Activités auxiliaires de services financiers, hors assurance et caisses de retraite',
            value: 'Activités auxiliaires de services financiers, hors assurance et caisses de retraite',
            classes: [
              { 
                default: 0,
                name: 'Administration de marchés financiers',
                value: 'Administration de marchés financiers',
              },
              { 
                default: 0,
                name: 'Courtage de valeurs mobilières et de marchandises',
                value: 'Courtage de valeurs mobilières et de marchandises',
              },
              { 
                default: 0,
                name: 'Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite',
                value: 'Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite',
              }      
            ]
          },
          {
            default: 0,
            name: 'Activités auxiliaires d\'assurance et de caisses de retraite',
            value: 'Activités auxiliaires d\'assurance et de caisses de retraite',
            classes: [
              { 
                default: 0,
                name: 'Évaluation des risques et dommages',
                value: 'Évaluation des risques et dommages',
              },
              { 
                default: 0,
                name: 'Activités des agents et courtiers d\'assurances',
                value: 'Activités des agents et courtiers d\'assurances',
              },
              { 
                default: 0,
                name: 'Autres activités auxiliaires d\'assurance et de caisses de retraite',
                value: 'Autres activités auxiliaires d\'assurance et de caisses de retraite',
              }    
            ]
          },
          {
            default: 0,
            name: 'Gestion de fonds',
            value: 'Gestion de fonds',
            classes: [
              { 
                default: 0,
                name: 'Autres Gestion de fonds',
                value: 'Autres Gestion de fonds',
              }    
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ACTIVITÉS IMMOBILIÈRES',
    value: 'ACTIVITÉS IMMOBILIÈRES',
    divisions: [
      {
        default: 0,
        name: 'Activités immobilières',
        value: 'Activités immobilières',
        groups: [
          {
            default: 0,
            name: 'Activités des marchands de biens immobiliers',
            value: 'Activités des marchands de biens immobiliers',
            classes: [
              { 
                default: 0,
                name: 'Activités des marchands de biens immobiliers',
                value: 'Activités des marchands de biens immobiliers',
              }       
            ]
          },
          {
            default: 0,
            name: 'Location et exploitation de biens immobiliers propres ou loués',
            value: 'Location et exploitation de biens immobiliers propres ou loués',
            classes: [
              { 
                default: 0,
                name: 'Location de logements',
                value: 'Location de logements',
              },
              { 
                default: 0,
                name: 'Location de terrains et d\'autres biens immobiliers',
                value: 'Location de terrains et d\'autres biens immobiliers',
              }       
            ]
          },
          {
            default: 0,
            name: 'Activités immobilières pour compte de tiers',
            value: 'Activités immobilières pour compte de tiers',
            classes: [
              { 
                default: 0,
                name: 'Agences immobilières',
                value: 'Agences immobilières',
              },
              { 
                default: 0,
                name: 'Administration de biens immobiliers',
                value: 'Administration de biens immobiliers',
              }        
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ACTIVITÉS SPÉCIALISÉES, SCIENTIFIQUES ET TECHNIQUES',
    value: 'ACTIVITÉS SPÉCIALISÉES, SCIENTIFIQUES ET TECHNIQUES',
    divisions: [
      {
        default: 0,
        name: 'Activités juridiques et comptables',
        value: 'Activités juridiques et comptables',
        groups: [
          {
            default: 0,
            name: 'Activités juridiques',
            value: 'Activités juridiques',
            classes: [
              { 
                default: 0,
                name: 'Activités juridiques',
                value: 'Activités juridiques',
              }       
            ]
          },
          {
            default: 0,
            name: 'Activités comptables',
            value: 'Activités comptables',
            classes: [
              { 
                default: 0,
                name: 'Activités comptables',
                value: 'Activités comptables',
              }    
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités des sièges sociaux; conseil de gestion',
        value: 'Activités des sièges sociaux; conseil de gestion',
        groups: [
          {
            default: 0,
            name: 'Activités des sièges sociaux',
            value: 'Activités des sièges sociaux',
            classes: [
              { 
                default: 0,
                name: 'Activités des sièges sociaux',
                value: 'Activités des sièges sociaux',
              }       
            ]
          },
          {
            default: 0,
            name: 'Conseil de gestion',
            value: 'Conseil de gestion',
            classes: [
              { 
                default: 0,
                name: 'Conseil en relations publiques et communication',
                value: 'Conseil en relations publiques et communication',
              },
              { 
                default: 0,
                name: 'Conseil pour les affaires et autres conseils de gestion',
                value: 'Conseil pour les affaires et autres conseils de gestion',
              }     
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités d\'architecture et d\'ingénierie; activités de contrôle et analyses techniques',
        value: 'Activités d\'architecture et d\'ingénierie; activités de contrôle et analyses techniques',
        groups: [
          {
            default: 0,
            name: 'Activités d\'architecture et d\'ingénierie',
            value: 'Activités d\'architecture et d\'ingénierie',
            classes: [
              { 
                default: 0,
                name: 'Activités d\'architecture',
                value: 'Activités d\'architecture',
              },
              { 
                default: 0,
                name: 'Activités d\'ingénierie',
                value: 'Activités d\'ingénierie',
              }       
            ]
          },
          {
            default: 0,
            name: 'Activités de contrôle et analyses techniques',
            value: 'Activités de contrôle et analyses techniques',
            classes: [
              { 
                default: 0,
                name: 'Activités de contrôle et analyses techniques',
                value: 'Activités de contrôle et analyses techniques',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Recherche développement scientifique',
        value: 'Recherche développement scientifique',
        groups: [
          {
            default: 0,
            name: 'Recherche-développement en sciences physiques et naturelles',
            value: 'Recherche-développement en sciences physiques et naturelles',
            classes: [
              { 
                default: 0,
                name: 'Recherche-développement en biotechnologie',
                value: 'Recherche-développement en biotechnologie',
              },
              { 
                default: 0,
                name: 'Recherche-développement en autres sciences physiques et naturelles',
                value: 'Recherche-développement en autres sciences physiques et naturelles',
              }       
            ]
          },
          {
            default: 0,
            name: 'Recherche-développement en sciences humaines et sociales',
            value: 'Recherche-développement en sciences humaines et sociales',
            classes: [
              { 
                default: 0,
                name: 'Recherche-développement en sciences humaines et sociales',
                value: 'Recherche-développement en sciences humaines et sociales',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Publicité et études de marché',
        value: 'Publicité et études de marché',
        groups: [
          {
            default: 0,
            name: 'Publicité',
            value: 'Publicité',
            classes: [
              { 
                default: 0,
                name: 'Activités des agences de publicité',
                value: 'Activités des agences de publicité',
              },
              { 
                default: 0,
                name: 'Régie publicitaire de médias',
                value: 'Régie publicitaire de médias',
              }       
            ]
          },
          {
            default: 0,
            name: 'Études de marché et sondages',
            value: 'Études de marché et sondages',
            classes: [
              { 
                default: 0,
                name: 'Études de marché et sondages',
                value: 'Études de marché et sondages',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Autres activités spécialisées, scientifiques et techniques',
        value: 'Autres activités spécialisées, scientifiques et techniques',
        groups: [
          {
            default: 0,
            name: 'Activités spécialisées de design',
            value: 'Activités spécialisées de design',
            classes: [
              { 
                default: 0,
                name: 'Activités spécialisées de design',
                value: 'Activités spécialisées de design',
              }    
            ]
          },
          {
            default: 0,
            name: 'Activités photographiques',
            value: 'Activités photographiques',
            classes: [
              { 
                default: 0,
                name: 'Activités photographiques',
                value: 'Activités photographiques',
              } 
            ]
          },
          {
            default: 0,
            name: 'Traduction et interprétation',
            value: 'Traduction et interprétation',
            classes: [
              { 
                default: 0,
                name: 'Traduction et interprétation',
                value: 'Traduction et interprétation',
              } 
            ]
          },
          {
            default: 0,
            name: 'Autres activités spécialisées, scientifiques et techniques n.c.a.',
            value: 'Autres activités spécialisées, scientifiques et techniques n.c.a.',
            classes: [
              { 
                default: 0,
                name: 'Autres activités spécialisées, scientifiques et techniques n.c.a.',
                value: 'Autres activités spécialisées, scientifiques et techniques n.c.a.',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités vétérinaires',
        value: 'Activités vétérinaires',
        groups: [
          {
            default: 0,
            name: 'Activités vétérinaires',
            value: 'Activités vétérinaires',
            classes: [
              { 
                default: 0,
                name: 'Activités vétérinaires',
                value: 'Activités vétérinaires',
              }    
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ACTIVITÉS DE SERVICES ADMINISTRATIFS ET DE SOUTIEN',
    value: 'ACTIVITÉS DE SERVICES ADMINISTRATIFS ET DE SOUTIEN',
    divisions: [
      {
        default: 0,
        name: 'Activités de location et location bail',
        value: 'Activités de location et location bail',
        groups: [
          {
            default: 0,
            name: 'Location et location-bail de véhicules automobiles',
            value: 'Location et location-bail de véhicules automobiles',
            classes: [
              { 
                default: 0,
                name: 'Location et location-bail de voitures et de véhicules automobiles légers',
                value: 'Location et location-bail de voitures et de véhicules automobiles légers',
              },
              { 
                default: 0,
                name: 'Location et location-bail de camions',
                value: 'Location et location-bail de camions',
              }        
            ]
          },
          {
            default: 0,
            name: 'Location et location-bail de biens personnels et domestiques',
            value: 'Location et location-bail de biens personnels et domestiques',
            classes: [
              { 
                default: 0,
                name: 'Location et location-bail d\'articles de loisirs et de sport',
                value: 'Location et location-bail d\'articles de loisirs et de sport',
              },
              { 
                default: 0,
                name: 'Location de vidéocassettes et disques vidéo',
                value: 'Location de vidéocassettes et disques vidéo',
              },
              { 
                default: 0,
                name: 'Location et location-bail d\'autres biens personnels et domestiques',
                value: 'Location et location-bail d\'autres biens personnels et domestiques',
              }    
            ]
          },
          {
            default: 0,
            name: 'Location et location-bail d\'autres machines, équipements et biens',
            value: 'Location et location-bail d\'autres machines, équipements et biens',
            classes: [
              { 
                default: 0,
                name: 'Location et location-bail de machines et équipements agricoles',
                value: 'Location et location-bail de machines et équipements agricoles',
              },
              { 
                default: 0,
                name: 'Location et location-bail de machines et équipements pour la construction',
                value: 'Location et location-bail de machines et équipements pour la construction',
              },
              { 
                default: 0,
                name: 'Location et location-bail de machines de bureau et de matériel informatique',
                value: 'Location et location-bail de machines de bureau et de matériel informatique',
              },
              { 
                default: 0,
                name: 'Location et location-bail de matériels de transport par eau',
                value: 'Location et location-bail de matériels de transport par eau',
              },
              { 
                default: 0,
                name: 'Location et location-bail de matériels de transport aérien',
                value: 'Location et location-bail de matériels de transport aérien',
              },
              { 
                default: 0,
                name: 'Location et location-bail d\'autres machines, équipements et biens matériels n.c.a.',
                value: 'Location et location-bail d\'autres machines, équipements et biens matériels n.c.a.',
              }    
            ]
          },
          {
            default: 0,
            name: 'Location-bail de propriété intellectuelle et de produits similaires, à l\'exception des œuvres soumises à copyright',
            value: 'Location-bail de propriété intellectuelle et de produits similaires, à l\'exception des œuvres soumises à copyright',
            classes: [
              { 
                default: 0,
                name: 'Location-bail de propriété intellectuelle et de produits similaires, à l\'exception des œuvres soumises à copyright',
                value: 'Location-bail de propriété intellectuelle et de produits similaires, à l\'exception des œuvres soumises à copyright',
              }    
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités liées à l\'emploi',
        value: 'Activités liées à l\'emploi',
        groups: [
          {
            default: 0,
            name: 'Activités des agences de placement de main-d\'œuvre',
            value: 'Activités des agences de placement de main-d\'œuvre',
            classes: [
              { 
                default: 0,
                name: 'Activités des agences de placement de main-d\'œuvre',
                value: 'Activités des agences de placement de main-d\'œuvre',
              }       
            ]
          },
          {
            default: 0,
            name: 'Activités des agences de travail temporaire',
            value: 'Activités des agences de travail temporaire',
            classes: [
              { 
                default: 0,
                name: 'Activités des agences de travail temporaire',
                value: 'Activités des agences de travail temporaire',
              } 
            ]
          },
          {
            default: 0,
            name: 'Autre mise à disposition de ressources humaines',
            value: 'Autre mise à disposition de ressources humaines',
            classes: [
              { 
                default: 0,
                name: 'Autre mise à disposition de ressources humaines',
                value: 'Autre mise à disposition de ressources humaines',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités des agences de voyage, voyagistes, services de réservation et activités connexes',
        value: 'Activités des agences de voyage, voyagistes, services de réservation et activités connexes',
        groups: [
          {
            default: 0,
            name: 'Activités des agences de voyage et voyagistes',
            value: 'Activités des agences de voyage et voyagistes',
            classes: [
              { 
                default: 0,
                name: 'Activités des agences de voyage',
                value: 'Activités des agences de voyage',
              },
              { 
                default: 0,
                name: 'Activités des voyagistes',
                value: 'Activités des voyagistes',
              }       
            ]
          },
          {
            default: 0,
            name: 'Autres services de réservation et activités connexes',
            value: 'Autres services de réservation et activités connexes',
            classes: [
              { 
                default: 0,
                name: 'Autres services de réservation et activités connexes',
                value: 'Autres services de réservation et activités connexes',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Enquêtes et sécurité',
        value: 'Enquêtes et sécurité',
        groups: [
          {
            default: 0,
            name: 'Activités de sécurité privée',
            value: 'Activités de sécurité privée',
            classes: [
              { 
                default: 0,
                name: 'Activités de sécurité privée',
                value: 'Activités de sécurité privée',
              },
              { 
                default: 0,
                name: 'Activités liées aux systèmes de sécurité',
                value: 'Activités liées aux systèmes de sécurité',
              }       
            ]
          },
          {
            default: 0,
            name: 'Activités d\'enquête',
            value: 'Activités d\'enquête',
            classes: [
              { 
                default: 0,
                name: 'Activités d\'enquête',
                value: 'Activités d\'enquête',
              } 
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Services relatifs aux bâtiments et aménagement paysager',
        value: 'Services relatifs aux bâtiments et aménagement paysager',
        groups: [
          {
            default: 0,
            name: 'Activités combinées de soutien lié aux bâtiments',
            value: 'Activités combinées de soutien lié aux bâtiments',
            classes: [
              { 
                default: 0,
                name: 'Activités combinées de soutien lié aux bâtiments',
                value: 'Activités combinées de soutien lié aux bâtiments',
              }      
            ]
          },
          {
            default: 0,
            name: 'Activités de nettoyage',
            value: 'Activités de nettoyage',
            classes: [
              { 
                default: 0,
                name: 'Nettoyage courant des bâtiments',
                value: 'Nettoyage courant des bâtiments',
              },
              { 
                default: 0,
                name: 'Autres activités de nettoyage des bâtiments et nettoyage industriel',
                value: 'Autres activités de nettoyage des bâtiments et nettoyage industriel',
              },
              { 
                default: 0,
                name: 'Autres activités de nettoyage',
                value: 'Autres activités de nettoyage',
              }
            ]
          },
          {
            default: 0,
            name: 'Services d\'aménagement paysager',
            value: 'Services d\'aménagement paysager',
            classes: [
              { 
                default: 0,
                name: 'Services d\'aménagement paysager',
                value: 'Services d\'aménagement paysager',
              }    
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités administratives et autres activités de soutien aux entreprises',
        value: 'Activités administratives et autres activités de soutien aux entreprises',
        groups: [
          {
            default: 0,
            name: 'Activités administratives',
            value: 'Activités administratives',
            classes: [
              { 
                default: 0,
                name: 'Services administratifs combinés de bureau',
                value: 'Services administratifs combinés de bureau',
              },
              { 
                default: 0,
                name: 'Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau',
                value: 'Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau',
              }  
            ]
          },
          {
            default: 0,
            name: 'Activités de centres d\'appels',
            value: 'Activités de centres d\'appels',
            classes: [
              { 
                default: 0,
                name: 'Activités de centres d\'appels',
                value: 'Activités de centres d\'appels',
              } 
            ]
          },
          {
            default: 0,
            name: 'Organisation de salons professionnels et congrès',
            value: 'Organisation de salons professionnels et congrès',
            classes: [
              { 
                default: 0,
                name: 'Organisation de salons professionnels et congrès',
                value: 'Organisation de salons professionnels et congrès',
              } 
            ]
          },
          {
            default: 0,
            name: 'Activités de soutien aux entreprises n.c.a.',
            value: 'Activités de soutien aux entreprises n.c.a.',
            classes: [
              { 
                default: 0,
                name: 'Activités des agences de recouvrement de factures et des sociétés d\'information financière sur la clientèle',
                value: 'Activités des agences de recouvrement de factures et des sociétés d\'information financière sur la clientèle',
              },
              { 
                default: 0,
                name: 'Activités de conditionnement',
                value: 'Activités de conditionnement',
              } ,
              { 
                default: 0,
                name: 'Autres activités de soutien aux entreprises n.c.a.',
                value: 'Autres activités de soutien aux entreprises n.c.a.',
              }  
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ADMINISTRATION PUBLIQUE',
    value: 'ADMINISTRATION PUBLIQUE',
    divisions: [
      {
        default: 0,
        name: 'Administration publique et défense; sécurité sociale obligatoire',
        value: 'Administration publique et défense; sécurité sociale obligatoire',
        groups: [
          {
            default: 0,
            name: 'Administration générale, économique et sociale',
            value: 'Administration générale, économique et sociale',
            classes: [
              { 
                default: 0,
                name: 'Administration publique centrale',
                value: 'Administration publique centrale',
              },
              { 
                default: 0,
                name: 'Administration des collectivités locales',
                value: 'Administration des collectivités locales',
              },
              { 
                default: 0,
                name: 'Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale',
                value: 'Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale',
              }        
            ]
          },
          {
            default: 0,
            name: 'Services de prérogative publique',
            value: 'Services de prérogative publique',
            classes: [
              { 
                default: 0,
                name: 'Affaires étrangères',
                value: 'Affaires étrangères',
              },
              { 
                default: 0,
                name: 'Défense',
                value: 'Défense',
              },
              { 
                default: 0,
                name: 'Justice',
                value: 'Justice',
              },
              { 
                default: 0,
                name: 'Activités d\'ordre public et de sécurité',
                value: 'Activités d\'ordre public et de sécurité',
              },
              { 
                default: 0,
                name: 'Services de protection civile',
                value: 'Services de protection civile',
              }    
            ]
          },
          {
            default: 0,
            name: 'Sécurité sociale obligatoire',
            value: 'Sécurité sociale obligatoire',
            classes: [
              { 
                default: 0,
                name: 'Sécurité sociale obligatoire',
                value: 'Sécurité sociale obligatoire',
              }  
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ENSEIGNEMENT',
    value: 'ENSEIGNEMENT',
    divisions: [
      {
        default: 0,
        name: 'Enseignement',
        value: 'Enseignement',
        groups: [
          {
            default: 0,
            name: 'Enseignement pré-primaire',
            value: 'Enseignement pré-primaire',
            classes: [
              { 
                default: 0,
                name: 'Enseignement pré-primaire',
                value: 'Enseignement pré-primaire',
              }      
            ]
          },
          {
            default: 0,
            name: 'Enseignement primaire',
            value: 'Enseignement primaire',
            classes: [
              { 
                default: 0,
                name: 'Enseignement primaire',
                value: 'Enseignement primaire',
              } 
            ]
          },
          {
            default: 0,
            name: 'Enseignement secondaire',
            value: 'Enseignement secondaire',
            classes: [
              { 
                default: 0,
                name: 'Enseignement secondaire (collège - 1er cycle)',
                value: 'Enseignement secondaire (collège - 1er cycle)',
              },
              { 
                default: 0,
                name: 'Enseignement secondaire (lycée - 2ème cycle)',
                value: 'Enseignement secondaire (lycée - 2ème cycle)',
              },
              { 
                default: 0,
                name: 'Enseignement secondaire technique ou professionnel',
                value: 'Enseignement secondaire technique ou professionnel',
              } 
            ]
          },
          {
            default: 0,
            name: 'Enseignement supérieur et post-secondaire non supérieur',
            value: 'Enseignement supérieur et post-secondaire non supérieur',
            classes: [
              { 
                default: 0,
                name: 'Enseignement post-secondaire non supérieur',
                value: 'Enseignement post-secondaire non supérieur',
              },
              { 
                default: 0,
                name: 'Enseignement supérieur',
                value: 'Enseignement supérieur',
              }
            ]
          },
          {
            default: 0,
            name: 'Autres activités d\'enseignement',
            value: 'Autres activités d\'enseignement',
            classes: [
              { 
                default: 0,
                name: 'Enseignement de disciplines sportives et d\'activités de loisirs',
                value: 'Enseignement de disciplines sportives et d\'activités de loisirs',
              },
              { 
                default: 0,
                name: 'Enseignement culturel',
                value: 'Enseignement culturel',
              },
              { 
                default: 0,
                name: 'Enseignement de la conduite',
                value: 'Enseignement de la conduite',
              },
              { 
                default: 0,
                name: 'Enseignements divers',
                value: 'Enseignements divers',
              }
            ]
          },
          {
            default: 0,
            name: 'Activités de soutien à l\'enseignement',
            value: 'Activités de soutien à l\'enseignement',
            classes: [
              { 
                default: 0,
                name: 'Activités de soutien à l\'enseignement',
                value: 'Activités de soutien à l\'enseignement',
              }
            ]
          },
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'SANTÉ HUMAINE ET ACTION SOCIALE',
    value: 'SANTÉ HUMAINE ET ACTION SOCIALE',
    divisions: [
      {
        default: 0,
        name: 'Activités pour la santé humaine',
        value: 'Activités pour la santé humaine',
        groups: [
          {
            default: 0,
            name: 'Activités hospitalières',
            value: 'Activités hospitalières',
            classes: [
              { 
                default: 0,
                name: 'Activités hospitalières',
                value: 'Activités hospitalières',
              }      
            ]
          },
          {
            default: 0,
            name: 'Activité des médecins et des dentistes',
            value: 'Activité des médecins et des dentistes',
            classes: [
              { 
                default: 0,
                name: 'Activité des médecins généralistes',
                value: 'Activité des médecins généralistes',
              },
              { 
                default: 0,
                name: 'Activité des médecins spécialistes',
                value: 'Activité des médecins spécialistes',
              },
              { 
                default: 0,
                name: 'Pratique dentaire',
                value: 'Pratique dentaire',
              }
            ]
          },
          {
            default: 0,
            name: 'Autres activités pour la santé humaine',
            value: 'Autres activités pour la santé humaine',
            classes: [
              { 
                default: 0,
                name: 'Laboratoires d\'analyses médicales',
                value: 'Laboratoires d\'analyses médicales',
              },
              { 
                default: 0,
                name: 'Ambulances',
                value: 'Ambulances',
              },
              { 
                default: 0,
                name: 'Activités des auxiliaires médicaux',
                value: 'Activités des auxiliaires médicaux',
              },
              { 
                default: 0,
                name: 'Autres activités pour la santé humaine',
                value: 'Autres activités pour la santé humaine',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Hébergement médico-social et social',
        value: 'Hébergement médico-social et social',
        groups: [
          {
            default: 0,
            name: 'Hébergement médicalisé',
            value: 'Hébergement médicalisé',
            classes: [
              { 
                default: 0,
                name: 'Hébergement médicalisé',
                value: 'Hébergement médicalisé',
              }      
            ]
          },
          {
            default: 0,
            name: 'Hébergement social pour personnes handicapées mentales, malades mentales et toxicomanes',
            value: 'Hébergement social pour personnes handicapées mentales, malades mentales et toxicomanes',
            classes: [
              { 
                default: 0,
                name: 'Hébergement social pour personnes handicapées mentales, malades mentales et toxicomanes',
                value: 'Hébergement social pour personnes handicapées mentales, malades mentales et toxicomanes',
              }
            ]
          },
          {
            default: 0,
            name: 'Hébergement social pour personnes âgées ou handicapées physiques',
            value: 'Hébergement social pour personnes âgées ou handicapées physiques',
            classes: [
              { 
                default: 0,
                name: 'Hébergement social pour personnes âgées ou handicapées physiques',
                value: 'Hébergement social pour personnes âgées ou handicapées physiques',
              }
            ]
          },
          {
            default: 0,
            name: 'Autres activités d\'hébergement social',
            value: 'Autres activités d\'hébergement social',
            classes: [
              { 
                default: 0,
                name: 'Autres activités d\'hébergement social',
                value: 'Autres activités d\'hébergement social',
              }
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Action sociale sans hébergement',
        value: 'Action sociale sans hébergement',
        groups: [
          {
            default: 0,
            name: 'Action sociale sans hébergement pour personnes âgées et pour personnes handicapées',
            value: 'Action sociale sans hébergement pour personnes âgées et pour personnes handicapées',
            classes: [
              { 
                default: 0,
                name: 'Action sociale sans hébergement pour personnes âgées et pour personnes handicapées',
                value: 'Action sociale sans hébergement pour personnes âgées et pour personnes handicapées',
              }      
            ]
          },
          {
            default: 0,
            name: 'Autre action sociale sans hébergement',
            value: 'Autre action sociale sans hébergement',
            classes: [
              { 
                default: 0,
                name: 'Action sociale sans hébergement pour jeunes enfants',
                value: 'Action sociale sans hébergement pour jeunes enfants',
              },
              { 
                default: 0,
                name: 'Autre action sociale sans hébergement n.c.a.',
                value: 'Autre action sociale sans hébergement n.c.a.',
              }
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'ARTS, SPECTACLES ET ACTIVITÉS RÉCRÉATIVES',
    value: 'ARTS, SPECTACLES ET ACTIVITÉS RÉCRÉATIVES',
    divisions: [
      {
        default: 0,
        name: 'Activités créatives, artistiques et de spectacle',
        value: 'Activités créatives, artistiques et de spectacle',
        groups: [
          {
            default: 0,
            name: 'Activités créatives, artistiques et de spectacle',
            value: 'Activités créatives, artistiques et de spectacle',
            classes: [
              { 
                default: 0,
                name: 'Arts du spectacle vivant',
                value: 'Arts du spectacle vivant',
              },
              { 
                default: 0,
                name: 'Activités de soutien au spectacle vivant',
                value: 'Activités de soutien au spectacle vivant',
              },
              { 
                default: 0,
                name: 'Création artistique',
                value: 'Création artistique',
              },
              { 
                default: 0,
                name: 'Gestion de salles de spectacles',
                value: 'Gestion de salles de spectacles',
              }     
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Bibliothèques, archives, musées et autres activités culturelles',
        value: 'Bibliothèques, archives, musées et autres activités culturelles',
        groups: [
          {
            default: 0,
            name: 'Bibliothèques, archives, musées et autres activités culturelles',
            value: 'Bibliothèques, archives, musées et autres activités culturelles',
            classes: [
              { 
                default: 0,
                name: 'Gestion des bibliothèques et des archives',
                value: 'Gestion des bibliothèques et des archives',
              },
              { 
                default: 0,
                name: 'Gestion des musées',
                value: 'Gestion des musées',
              },
              { 
                default: 0,
                name: 'Gestion des sites et monuments historiques et des attractions touristiques similaires',
                value: 'Gestion des sites et monuments historiques et des attractions touristiques similaires',
              },
              { 
                default: 0,
                name: 'Gestion des jardins botaniques et zoologiques et des réserves naturelles',
                value: 'Gestion des jardins botaniques et zoologiques et des réserves naturelles',
              }     
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Organisation de jeux de hasard et d\'argent',
        value: 'Organisation de jeux de hasard et d\'argent',
        groups: [
          {
            default: 0,
            name: 'Organisation de jeux de hasard et d\'argent',
            value: 'Organisation de jeux de hasard et d\'argent',
            classes: [
              { 
                default: 0,
                name: 'Organisation de jeux de hasard et d\'argent',
                value: 'Organisation de jeux de hasard et d\'argent',
              }      
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités sportives, récréatives et de loisirs',
        value: 'Activités sportives, récréatives et de loisirs',
        groups: [
          {
            default: 0,
            name: 'Activités liées au sport',
            value: 'Activités liées au sport',
            classes: [
              { 
                default: 0,
                name: 'Gestion d\'installations sportives',
                value: 'Gestion d\'installations sportives',
              },
              { 
                default: 0,
                name: 'Activités de clubs de sports',
                value: 'Activités de clubs de sports',
              },
              { 
                default: 0,
                name: 'Activités des centres de culture physique',
                value: 'Activités des centres de culture physique',
              },
              { 
                default: 0,
                name: 'Autres activités liées au sport',
                value: 'Autres activités liées au sport',
              },      
            ]
          },
          {
            default: 0,
            name: 'Activités récréatives et de loisirs',
            value: 'Activités récréatives et de loisirs',
            classes: [
              { 
                default: 0,
                name: 'Activités des parcs d\'attractions et parcs à thèmes',
                value: 'Activités des parcs d\'attractions et parcs à thèmes',
              },
              { 
                default: 0,
                name: 'Autres activités récréatives et de loisirs',
                value: 'Autres activités récréatives et de loisirs',
              }      
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'AUTRES ACTIVITÉS DE SERVICES',
    value: 'AUTRES ACTIVITÉS DE SERVICES',
    divisions: [
      {
        default: 0,
        name: 'Activités des organisations associatives',
        value: 'Activités des organisations associatives',
        groups: [
          {
            default: 0,
            name: 'Activités des organisations économiques, patronales et professionnelles',
            value: 'Activités des organisations économiques, patronales et professionnelles',
            classes: [
              { 
                default: 0,
                name: 'Activités des organisations patronales et consulaires',
                value: 'Activités des organisations patronales et consulaires',
              },
              { 
                default: 0,
                name: 'Activités des organisations professionnelles',
                value: 'Activités des organisations professionnelles',
              }   
            ]
          },
          {
            default: 0,
            name: 'Activités des syndicats de salariés',
            value: 'Activités des syndicats de salariés',
            classes: [
              { 
                default: 0,
                name: 'Activités des syndicats de salariés',
                value: 'Activités des syndicats de salariés',
              }
            ]
          },
          {
            default: 0,
            name: 'Activités des autres organisations associatives',
            value: 'Activités des autres organisations associatives',
            classes: [
              { 
                default: 0,
                name: 'Activités des organisations religieuses',
                value: 'Activités des organisations religieuses',
              },
              { 
                default: 0,
                name: 'Activités des organisations politiques',
                value: 'Activités des organisations politiques',
              },
              { 
                default: 0,
                name: 'Activités des organisations associatives n.c.a.',
                value: 'Activités des organisations associatives n.c.a.',
              }   
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Réparation d\'ordinateurs et de biens personnels et domestiques',
        value: 'Réparation d\'ordinateurs et de biens personnels et domestiques',
        groups: [
          {
            default: 0,
            name: 'Réparation d\'ordinateurs et d\'équipements de communication',
            value: 'Réparation d\'ordinateurs et d\'équipements de communication',
            classes: [
              { 
                default: 0,
                name: 'Réparation d\'ordinateurs et d\'équipements périphériques',
                value: 'Réparation d\'ordinateurs et d\'équipements périphériques',
              },
              { 
                default: 0,
                name: 'Réparation d\'équipements de communication',
                value: 'Réparation d\'équipements de communication',
              }     
            ]
          },
          {
            default: 0,
            name: 'Réparation de biens personnels et domestiques',
            value: 'Réparation de biens personnels et domestiques',
            classes: [
              { 
                default: 0,
                name: 'Réparation de produits électroniques grand public',
                value: 'Réparation de produits électroniques grand public',
              },
              { 
                default: 0,
                name: 'Réparation d\'appareils électroménagers et d\'équipements pour la maison et le jardin',
                value: 'Réparation d\'appareils électroménagers et d\'équipements pour la maison et le jardin',
              },
              { 
                default: 0,
                name: 'Réparation de chaussures et d\'articles en cuir',
                value: 'Réparation de chaussures et d\'articles en cuir',
              },
              { 
                default: 0,
                name: 'Réparation de meubles et d\'équipements du foyer',
                value: 'Réparation de meubles et d\'équipements du foyer',
              },
              { 
                default: 0,
                name: 'Réparation d\'articles d\'horlogerie et de bijouterie',
                value: 'Réparation d\'articles d\'horlogerie et de bijouterie',
              },
              { 
                default: 0,
                name: 'Réparation d\'autres biens personnels et domestiques',
                value: 'Réparation d\'autres biens personnels et domestiques',
              }    
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Autres services personnels',
        value: 'Autres services personnels',
        groups: [
          {
            default: 0,
            name: 'Autres services personnels',
            value: 'Autres services personnels',
            classes: [
              { 
                default: 0,
                name: 'Blanchisserie teinturerie',
                value: 'Blanchisserie teinturerie',
              },
              { 
                default: 0,
                name: 'Coiffure et soins de beauté',
                value: 'Coiffure et soins de beauté',
              },
              { 
                default: 0,
                name: 'Services funéraires',
                value: 'Services funéraires',
              },
              { 
                default: 0,
                name: 'Activités thermales et de thalassothérapie',
                value: 'Activités thermales et de thalassothérapie',
              },
              { 
                default: 0,
                name: 'Bains et autres soins corporels',
                value: 'Bains et autres soins corporels',
              },
              { 
                default: 0,
                name: 'Autres services personnels n.c.a.',
                value: 'Autres services personnels n.c.a.',
              }      
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'Activités des ménages en tant qu\'employeurs; activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre',
    value: 'Activités des ménages en tant qu\'employeurs; activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre',
    divisions: [
      {
        default: 0,
        name: 'Activités des ménages en tant qu\'employeurs de personnel domestique',
        value: 'Activités des ménages en tant qu\'employeurs de personnel domestique',
        groups: [
          {
            default: 0,
            name: 'Activités des ménages en tant qu\'employeurs de personnel domestique',
            value: 'Activités des ménages en tant qu\'employeurs de personnel domestique',
            classes: [
              { 
                default: 0,
                name: 'Activités des ménages en tant qu\'employeurs de personnel domestique',
                value: 'Activités des ménages en tant qu\'employeurs de personnel domestique',
              }  
            ]
          }
        ]
      },
      {
        default: 0,
        name: 'Activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre',
        value: 'Activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre',
        groups: [
          {
            default: 0,
            name: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
            value: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
            classes: [
              { 
                default: 0,
                name: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
                value: 'Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre',
              }    
            ]
          },
          {
            default: 0,
            name: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
            value: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
            classes: [
              { 
                default: 0,
                name: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
                value: 'Activités indifférenciées des ménages en tant que producteurs de services pour usage propre',
              } 
            ]
          }
        ]
      }
    ]
  },
  {
    default: 0,
    name: 'Activités extra territoriales',
    value: 'Activités extra territoriales',
    divisions: [
      {
        default: 0,
        name: 'Activités des organisations et organismes extraterritoriaux',
        value: 'Activités des organisations et organismes extraterritoriaux',
        groups: [
          {
            default: 0,
            name: 'Activités des organisations et organismes extraterritoriaux',
            value: 'Activités des organisations et organismes extraterritoriaux',
            classes: [
              { 
                default: 0,
                name: 'Activités des organisations et organismes extraterritoriaux',
                value: 'Activités des organisations et organismes extraterritoriaux',
              }  
            ]
          }
        ]
      }
    ]
  },
  // Add another Section
];